/* Verso Studio : éditeur de personnalisation (texte + image) sur gabarit Printful. */
(() => {
  const root = document.getElementById('verso-studio');
  if (!root) return;

  const BACKEND = root.dataset.backend.replace(/\/$/, '');
  const PRODUCT = root.dataset.product;
  const productData = JSON.parse(root.querySelector('[data-vs-product]').textContent);
  // Le filtre `t` de Shopify échappe le HTML (l'image → l&#39;image) : on décode les entités pour les libellés posés en textContent.
  const decodeEntities = (s) => { const t = document.createElement('textarea'); t.innerHTML = s; return t.value; };
  const I18N = (() => { try { return Object.fromEntries(Object.entries(JSON.parse(root.querySelector('[data-vs-i18n]').textContent)).map(([k, v]) => [k, typeof v === 'string' ? decodeEntities(v) : v])); } catch { return {}; } })();
  const T = (k, vars) => Object.entries(vars || {}).reduce((t, [n, v]) => t.replace(new RegExp(`\\{\\{\\s*${n}\\s*\\}\\}|\\{${n}\\}`, 'g'), v), I18N[k] || k);

  // Panneaux imprimables d'un all-over, dans l'ordre des onglets. Doit suivre AOP_SIDES côté studio.
  const AOP_PANELS = ['front', 'back', 'hood', 'sleeve_left', 'sleeve_right'];

  const FONT_FAMILY = { bodonimoda: 'Bodoni Moda', jost: 'Jost' };
  const FONT_LABEL = { bodonimoda: 'Bodoni Moda', jost: 'Jost' };
  const INK = { cafe: '#2B211C', ivoire: '#F2E8D5', vert: '#2E5A3E', rouge: '#B23A2E', or: '#D4A24C', noir: '#111111', blanc: '#FFFFFF' };
  const INK_NAMES = { cafe: 'deep coffee brown', ivoire: 'ivory', vert: 'deep bottle green', rouge: 'warm brick red', or: 'aged brass gold', noir: 'black', blanc: 'white' };
  const GARMENT = {
    naturel: '#EFE6CF', noir: '#161616', 'forêt': '#243F2D', 'argile chiné': '#B59C86', ivoire: '#F1E9D6', 'desert dust': '#D8C3A6',
    blanc: '#FAFAFA', 'bleu marine': '#1E2433', marine: '#1E2433', kaki: '#5E5B3F', sable: '#D9C7A6', brique: '#8C3F31', mousse: '#5C6B4A',
    'gris chiné': '#A9A9A9', anthracite: '#3A3A3A', olive: '#5B5E3A', 'vert bouteille': '#2E5A3E', rouge: '#8C2F2A', pepper: '#5A5148', poivre: '#5A5148',
    'écru': '#F2ECDD', 'blanc cassé': '#F6F3EA', lavande: '#DFD9E7', rose: '#F5B5C8', 'vert sauge': '#53705F', 'rose brume': '#CBA59B', 'orchidée': '#F6E9EC', 'minéral': '#8FA7A6', 'rose pâle': '#FFD4C5', 'rose bonbon': '#FFC5D4', corail: '#FF735C', 'poussière chiné': '#C9BFB4', 'bleu jean': '#5B6E8C', beurre: '#F3E5B0',
    'blanc vintage': '#fff6e9', 'pierre': '#eddeb9', 'denim délavé': '#c9d0d6', 'anthracite délavé': '#4d473b', 'bordeaux délavé': '#72373c', 'noir délavé': '#1c1c18', 'blanc chiné': '#ffffff', 'émeraude chiné': '#142c1e', 'bordeaux chiné': '#744e5a', 'marine chiné': '#464d7e', 'noir chiné': '#101211', 'moutarde chiné': '#e3ac56', 'marine blazer': '#1b2229', 'noir vintage': '#363533', 'poussière': '#f4e7d6', 'bordeaux': '#621926', 'asphalte': '#716b63', 'brun vintage': '#9e7551', 'crème': '#fff4db', 'vert kaki': '#3c3d2e', 'sorbet citron': '#fff7b4', 'violet': '#8c92c1', 'anthracite chiné': '#3c3d44', 'mauve chiné': '#b97b7e', 'gris foncé chiné': '#323232', 'rose chiné': '#ffd7de', 'bleu layette chiné': '#c3dbf0', 'bleu lagon': '#52c7bd', 'rose vif': '#ff7289', 'orage': '#746e72', 'vert militaire': '#6a6c54', 'bleu royal': '#1d50a4', 'orange brûlé': '#ff613d', 'bleu clair': '#d4ebff', 'canneberge': '#a3001b', 'gris foncé': '#39353a', 'marine foncé': '#15293a', 'naturel / noir': '#f5eee1', 'gris chiné / noir': '#A8A59E', 'noir / rouge': '#2a2a2a', 'brun': '#1f0a03', 'épicéa': '#005234', 'rose layette': '#ffc6cd', 'gris': '#8D8790', 'marine / blanc': '#24303b', 'caramel': '#97622e', 'sapin': '#385e3d', 'gris chiné / blanc': '#a4a3a3', 'anthracite / noir': '#3f3c38', 'camel': '#b3753d', 'olive foncé': '#374225', 'marine oxford': '#181e42', 'corde': '#ffead1', 'pierre naturelle': '#f2eee4', 'vert frais': '#e5f0e2', 'rose frais': '#ffeae4', // couleurs générées (phase A)
    'rs sport gris': '#bebbba', 'irish vert': '#00b365', 'azalea': '#ff94ba', 'rouge sorbet': '#e57360', 'artichoke': '#99a173', 'latte': '#a8826b', 'pine': '#596a58', 'blanc / noir': '#ffffff', 'blanc / bleu royal': '#ffffff', 'blanc / bleu layette': '#ffffff', 'blanc / marine': '#ffffff', 'blanc / rose': '#ffffff', 'blanc / rouge': '#ffffff', 'marine vintage': '#101825', 'rouge vintage': '#bd1425', 'premium chiné': '#74716c', 'violet rush': '#3b1b6f', 'royal vintage': '#0e448e', 'turquoise vintage': '#0292cb', 'charity rose': '#fa6f9d', 'berry': '#eb498a', 'slate chiné': '#557589', 'turquoise': '#4dd9ed', 'gris marle': '#a4a4a5', 'coal': '#3b3232', 'sage': '#738e76', 'columbia bleu chiné': '#6495ff', 'yellow': '#ffea75', 'naturel chiné': '#fff7e6', 'kelly': '#00885d', 'raspberry': '#ff7fac', 'rose clair': '#ffdcdc', 'bleu layette': '#96bbe5', 'chalky mint': '#a1f2dc', 'cramoisi': '#c25d57', 'pêche': '#ffc7ad', 'collegiate marine': '#020b26', 'os': '#fff4da', 'carbon gris': '#cac8c8', 'heavy metal': '#454641', 'vert': '#1f9753', 'orange': '#ff6a00', 'graphite noir': '#383435', 'midnight marine': '#1d242e', 'harbor bleu': '#474f5d', 'agave': '#a4c2c8', 'brick rouge': '#8f242e', 'or vintage': '#ffce88', 'pacific bleu': '#91f2ff', 'burgundy': '#63222a', 'pale bleu': '#bed3d6', 'steel gris': '#47525c', 'cool chiné': '#a9b3b6', 'noir / blanc': '#0a0a0a', 'blanc / kelly': '#ffffff', 'blanc / anthracite chiné': '#ffffff', 'crème bleu': '#03b2f0', 'anthracite gris': '#4e494d', 'oatmeal': '#d8d2c2', 'pierre gris': '#a8a197', 'or': '#ffa10e', 'graphite': '#8b8e8f', 'scarlet': '#f31424', 'steel clair': '#e9e9e3', 'mulled berry': '#c02f3d', 'ice gris': '#E9DDDC', 'army vert foncé': '#999681', 'garnet rouge': '#e04f53', 'denim bleu': '#8c9fbd', 'anthracite melange': '#363436', 'bottle vert': '#344d34', 'india ink gris': '#333739', 'coyote brun': '#a67d46', 'dusty rose': '#f59382', 'classic marine': '#252b3b', 'alpine vert': '#406a59', 'sand kaki': '#cca46b', 'mixed gris': '#b4b4b4', 'g. dyed noir rock': '#2b2928', 'g. dyed pierre': '#d4cdb7', 'g. dyed misty gris': '#a4a8a4', 'g. dyed anthracite': '#534f4e', 'g. dyed vert sauge': '#7a8f8a', 'g. dyed deep bleu canard': '#586b7d', 'g. dyed kaffa coffee': '#a7847d', 'café': '#966f56', 'hydrangea': '#e3f3ff', 'faded noir': '#55565a', 'faded crème': '#FFF9E9', 'faded marine': '#4F5C71', 'faded brun': '#897561', 'faded moutarde': '#D0AB73', 'vert clair': '#5e856c', 'bleu épicéa': '#5a7260', 'flo bleu': '#8695d4', 'sandstone': '#bbb69c', 'rouge orange fluo': '#ff6c5d', 'noir camouflage': '#1a1a1a', 'forest camouflage': '#484a38', 'orage bleu': '#8e9299', 'army': '#7e7549', 'gris vintage chiné': '#fff9f1', 'anthracite noir chiné': '#070707', 'royal chiné': '#395dc7', 'j. marine': '#131b2c', 'blanc marle': '#e1e1e1', 'gris chiné foncé': '#444444', 'dusty sage': '#d9d9bd', 'ash': '#e1e1e1', 'marine bleu': '#0e121e', 'deep anthracite gris': '#40362f', 'gris melange': '#dedae3', 'soft rose': '#FFEAE5', 'milky way': '#a682ae', 'sherbet rainbow': '#ef8fbf', 'classic rainbow': '#eee448', 'pigment noir': '#514d49', 'pigment alpine vert': '#566d58', 'pigment bordeaux': '#b26e6f', 'pigment rose': '#ff908f', 'pigment slate bleu': '#81949c', 'pigment bleu clair': '#a8c4e1', 'sandshell': '#fff6e3', 'oatmeal chiné': '#f7f2eb', 'sports vert': '#2e4030', 'cardinal': '#d02c38', 'midnight bleu': '#36394f', 'cypress': '#6a6e5c', 'argile': '#a8593d', 'petrol bleu': '#464e57', 'forêt chiné': '#3f4a48', 'gris clair': '#bdb6b3', 'beige clair': '#dbc6b2', 'shadow': '#848480', 'pine vert': '#113433', 'ciel bleu': '#a1c2d9', 'chestnut': '#814733', 'naturel / forêt': '#fff1cc', 'naturel / midnight marine': '#fff1cc', 'smoke noir': '#2e2c29', 'pigment midnight marine': '#434c4c', 'pigment burro': '#deaa76', 'pigment lunar rock': '#fff9ec', 'pebble bleu': '#5c8196', 'burro': '#bd9b7a', 'pistachio': '#dfeadc', 'oil vert': '#afb584', 'lunar rock': '#fff9ec', 'salmon': '#ffb7a1', 'vert tiger camouflage': '#5e5f56', 'noir / blanc / noir': '#e3e7ed', 'argent / noir': '#c7bdb2', 'anthracite / blanc': '#554b56', 'kelly / blanc / kelly': '#e3e7ed', 'marine / blanc / marine': '#e3e7ed', 'camouflage / noir': '#576352', 'camouflage / olive': '#bbafa8', 'camouflage / brun': '#696651', 'multicam noir': '#131211', 'bleu': '#5c839a', 'vert foncé': '#3c5247', 'walnut': '#59392b', 'noir / gris': '#24292f', 'bleu / blanc / bleu': '#009bce', 'vert foncé / blanc / vert foncé': '#062611', 'rose vif / blanc / rose vif': '#ff266f', 'rose clair / blanc / rose clair': '#ffd7dd', 'turquoise / blanc': '#09ceeb', 'lt gris / marine': '#d3d4be', 'marine / mint': '#0e1524', 'yellow / marine': '#ffe899', 'jungle': '#928355', 'pacific': '#061226', 'bio blanc': '#ffffff', 'slate bleu': '#87b0ca', 'dill': '#6f8269', 'leaf vert': '#d2db6b', 'avio bleu clair': '#88c7eb', 'moutarde yellow': '#ffbb4f', 'marine / kaki': '#fae2bb', 'vert foncé / kaki': '#fae2bb', 'pastel rose': '#fff0ef', 'pastel bleu': '#e6f2fa', 'beige': '#efe7d4', 'pastel citron': '#fffbe1', 'pastel mint': '#f8fff8', 'graphite gris': '#434341', 'moss vert': '#524d23', 'gris foncé chiné / noir': '#56524f', 'gris foncé chiné / marine': '#55524f', 'gris foncé chiné / rouge': '#57514e', 'bleu royal / gris chiné': '#004074', 'gris melange clair': '#b8b3af', 'acid vert': '#e3ff82', 'moutarde': '#f19f00', 'noir / anthracite': '#000000', 'loden': '#8e845e', 'aigue-marine bleu / noir / noir': '#1a1616', 'noir / anthracite gris / anthracite gris': '#4d4f4c', 'noir / gris / gris': '#afadaa', 'noir / blanc / blanc': '#ffffff', 'or / noir / noir': '#1a1616', 'gris / noir / noir': '#1a1616', 'orange / noir / noir': '#1a1616', 'castlerock': '#898a84', 'birch': '#ffeeca', 'rust': '#bf4015', // couleurs générées (phase A)
    'avoine': '#d8d2c2', 'avoine chiné': '#f7f2eb', 'sable clair': '#fff6e3', 'gris carbone': '#cac8c8', 'rouge cardinal': '#d02c38', 'menthe pâle': '#a1f2dc', 'châtaigne': '#814733', 'marine classique': '#252b3b', 'arc-en-ciel': '#eee448', 'bleu ciel chiné': '#6495ff', 'gris chiné clair': '#a9b3b6', 'cyprès': '#6a6e5c', 'anthracite profond': '#40362f', 'bleu denim': '#8c9fbd', 'vieux rose': '#f59382', 'sauge poudré': '#d9d9bd', 'camouflage forêt': '#484a38', 'bleu canard délavé': '#586b7d', 'gris graphite': '#434341', 'noir graphite': '#383435', 'gris chiné vintage': '#fff9f1', 'vert irlandais': '#00b365', 'vert kelly': '#00885d', 'vert kelly / blanc': '#e3e7ed', 'blanc / vert kelly': '#ffffff', 'marine / menthe': '#0e1524', 'vert mousse': '#524d23', 'jaune moutarde': '#ffbb4f', 'mûre': '#c02f3d', 'orange / noir': '#1a1616', 'bleu pâle': '#bed3d6', 'menthe pastel': '#f8fff8', 'rose pastel': '#fff0ef', 'bleu galet': '#5c8196', 'bleu pétrole': '#464e57', 'bleu ardoise pigmenté': '#81949c', 'rose pigmenté': '#ff908f', 'pin': '#596a58', 'vert pin': '#113433', 'gris sport': '#bebbba', 'rose clair / blanc': '#ffd7dd', 'rose vif / blanc': '#ff266f', 'orange fluo': '#ff6c5d', 'bleu royal chiné': '#395dc7', 'bleu royal vintage': '#0e448e', 'rouille': '#bf4015', 'sauge': '#738e76', 'saumon': '#ffb7a1', 'kaki sable': '#cca46b', 'bleu ardoise': '#87b0ca', 'ardoise chiné': '#557589', 'noir fumé': '#2e2c29', 'rose doux': '#FFEAE5', 'acier clair': '#e9e9e3', 'gris acier': '#47525c', 'violet vif': '#3b1b6f', 'noyer': '#59392b', 'jaune': '#ffea75', 'jaune / marine': '#ffe899', 'rouge brique': '#8f242e', 'baie': '#eb498a', 'cendre': '#e1e1e1', // couleurs renommées
    'gris chiné froid': '#e8e8e8', 'bleu lagon chiné': '#8eb9bd', 'rouge chiné': '#f5575c', 'pierre chiné': '#c6b7a7', 'vert feuille': '#84a357', 'violet clair': '#e1c4cf', 'mauve': '#ba756c', 'bleu canard chiné': '#4a7486', 'bleu cancún': '#c2faf9', 'orange clair': '#ff9967', 'peach': '#f8bc9f', // couleurs générées (phase A)
    'aigue-marine': '#008db5', 'vert armée': '#5f5849', 'automne': '#c85313', 'aigue-marine chiné': '#27a8c8', 'autumn chiné': '#D5743F', 'brun chiné': '#6A513A', 'ciel bleu chiné': '#ABC3EF', 'grass vert chiné': '#477749', 'ice bleu chiné': '#e8fdff', 'vert kelly chiné': '#00a263', 'midnight marine chiné': '#302d4b', 'menthe chiné': '#b2ebcf', 'olive chiné': '#5c5531', 'orange chiné': '#ff6f4e', 'orchid chiné': '#c2878e', 'prism poudré bleu chiné': '#a5c8bc', 'prism ice bleu chiné': '#c3e2e3', 'prism lilac chiné': '#deafcd', 'prism menthe chiné': '#aad5b9', 'prism peach chiné': '#f3c2b2', 'raspberry chiné': '#d23d62', 'team violet chiné': '#B680C1', 'jaune or chiné': '#FFB834', 'lilas': '#efbbe3', 'menthe': '#a5f4bd', 'bleu océan': '#a9dff6', 'oxblood noir': '#2c1013', 'galet': '#9a8479', 'argent': '#e3e3dd', 'doux crème': '#e7d4c0', 'doux rose': '#ffd8e1', 'bleu acier': '#668ea7', 'bleu canard': '#00e3cf', 'rose coton': '#ffe9eb', 'bleu foncé chiné': '#7a8ca8', 'pêche fraîche': '#ffd2be', 'bleu céleste': '#3d737d', 'émeraude': '#306d6e', 'citron fluo': '#efff99', 'rose fluo': '#ff5ea1', 'blossom': '#ffd6e1', 'pâle menthe': '#a1f2dc', 'chambray': '#d9f3ff', 'crunchberry': '#ff748e', 'denim': '#565a67', 'bleu vif': '#5669be', 'granite': '#a6abaa', 'raisin': '#644E6D', 'hemp': '#4F5232', 'ice bleu': '#7a9096', 'vert récif': '#b8ffca', 'midnight': '#3a4e63', 'bleu mystique': '#5068AB', 'paprika': '#fe4747', 'vert d\'eau': '#69a999', 'terracotta': '#ff9364', 'rose pastèque': '#d15c68', 'patate douce': '#db642f', 'chocolat': '#35241b', 'graphite chiné': '#686868', 'sport marine chiné foncé': '#515A6E', 'fuchsia': '#F63880', 'indigo bleu': '#395d82', 'rose azalée': '#ff9faf', 'beige chiné': '#cdb9a6', 'gris chiné chiné': '#a49895', 'baie chiné': '#bc437c', 'bleu chiné': '#62749b', 'violet chiné': '#846394', 'blanc moucheté chiné': '#eaeaea', 'desert rose': '#ffb095', 'cool bleu': '#003d68', 'gris métal': '#474445', 'courge': '#ffbf6e', 'pâle bleu': '#bed3d6', 'denim chiné / marine': '#2b354a', 'gris chiné / anthracite chiné': '#a3a5a9', 'gris chiné / rouge chiné': '#a3a5a9', 'blonde': '#fff7e5', 'hunter vert': '#3e3f2c', 'vert citron': '#e5fed3', 'safety vert': '#e0fee1', 'bleu ciel': '#8fc2e5', 'tiffany bleu': '#9cdddf', 'corail soyeux': '#ff7b71', 'cornsilk': '#FFEA8A', 'jaune pâquerette': '#FFC946', 'indigo chiné': '#677B90', 'irlandais vert chiné': '#38B777', 'vert jade': '#00b09d', 'saphir': '#007AB3', 'bleu tropical': '#00A0B3', 'tan chiné': '#ebcfa7', 'brun savana': '#9f8971', 'vert gazon': '#187532', 'jaune haze': '#FFD99C', 'profond royal chiné': '#6898f2', 'bright saumon': '#ff6f4b', 'melon': '#ff9455', 'bleu caraïbe': '#2089c5', 'darkwood tree camouflage': '#464646', 'deadwood tree camouflage': '#a5a3a1', 'duck camouflage': '#a68669', 'bleu orage': '#8e9299', 'charbon': '#28282a', 'bleu poudre': '#c7ede4', 'powder rose': '#f4dce4', 'vert alpin': '#2c493a', 'bleu aigue-marine': '#beeaff', 'classique marine': '#252b3b', 'poudré sauge': '#d9d9bd', 'gris acier chiné': '#9e9e9e', 'fumé': '#464341', 'citron': '#ffc402', 'brique adobe': '#d06e26', 'café au lait': '#b28a68', 'carbone gris': '#c7c3be', 'poudré rose': '#d27e6f', 'vert agave': '#c0d7d2', 'pétrole bleu': '#464e57', 'asphalte marle': '#2c2c2c', 'bleu royal vif': '#336ec6', 'bleu cobalt': '#30478a', 'pin vert': '#113433', 'army vert': '#45402a', 'menthe vert': '#57ebbe', 'fumé noir': '#2e2c29', // couleurs générées (phase A)
  };
  const DARK = ['noir', 'forêt', 'bleu marine', 'marine', 'kaki', 'brique', 'mousse', 'anthracite', 'olive', 'vert bouteille', 'rouge', 'pepper', 'poivre', 'vert sauge', 'bleu jean', 'minéral', 'anthracite délavé', 'bordeaux délavé', 'noir délavé', 'argile chiné', 'émeraude chiné', 'bordeaux chiné', 'marine chiné', 'noir chiné', 'marine blazer', 'noir vintage', 'bordeaux', 'vert kaki', 'anthracite chiné', 'gris foncé chiné', 'bleu royal', 'canneberge', 'gris foncé', 'marine foncé', 'noir / rouge', 'brun', 'épicéa', 'marine / blanc', 'sapin', 'anthracite / noir', 'olive foncé', 'marine oxford', 'pine', 'marine vintage', 'rouge vintage', 'violet rush', 'royal vintage', 'coal', 'gris', 'collegiate marine', 'heavy metal', 'graphite noir', 'midnight marine', 'harbor bleu', 'brick rouge', 'burgundy', 'steel gris', 'noir / blanc', 'anthracite gris', 'scarlet', 'mulled berry', 'anthracite melange', 'bottle vert', 'india ink gris', 'vert militaire', 'classic marine', 'alpine vert', 'g. dyed noir rock', 'g. dyed anthracite', 'faded noir', 'faded marine', 'bleu épicéa', 'noir camouflage', 'forest camouflage', 'anthracite noir chiné', 'gris chiné', 'royal chiné', 'j. marine', 'gris chiné foncé', 'marine bleu', 'deep anthracite gris', 'pigment noir', 'sports vert', 'cardinal', 'midnight bleu', 'petrol bleu', 'forêt chiné', 'pine vert', 'chestnut', 'smoke noir', 'pigment midnight marine', 'vert tiger camouflage', 'anthracite / blanc', 'camouflage / noir', 'camouflage / brun', 'multicam noir', 'vert foncé', 'cypress', 'walnut', 'noir / gris', 'vert foncé / blanc / vert foncé', 'rose vif / blanc / rose vif', 'kelly / blanc / kelly', 'marine / blanc / marine', 'marine / mint', 'pacific', 'denim bleu', 'graphite gris', 'moss vert', 'gris foncé chiné / noir', 'gris foncé chiné / marine', 'gris foncé chiné / rouge', 'bleu royal / gris chiné', 'noir / anthracite', 'aigue-marine bleu / noir / noir', 'noir / anthracite gris / anthracite gris', 'or / noir / noir', 'gris / noir / noir', 'orange / noir / noir', 'rust', 'vert armée', 'asphalte', 'baie', 'rouge cardinal', 'brun chiné', 'midnight marine chiné', 'olive chiné', 'raspberry chiné', 'ardoise chiné', 'oxblood noir', 'violet', 'émeraude', 'denim', 'raisin', 'graphite', 'hemp', 'midnight', 'sauge', 'chocolat', 'sport marine chiné foncé', 'fuchsia', 'indigo bleu', 'bleu canard chiné', 'baie chiné', 'cool bleu', 'gris métal', 'denim chiné / marine', 'hunter vert', 'vert kelly', 'saphir', 'vert gazon', 'darkwood tree camouflage', 'charbon', 'vert alpin', 'classique marine', 'fumé', 'pétrole bleu', 'asphalte marle', 'châtaigne', 'argile', 'bleu cobalt', 'pin vert', 'army vert', 'fumé noir'];
  const PRESETS = { chest: { x: 0.3, y: 0.1, width: 0.62, size: 0.045 }, center: { x: 0.5, y: 0.32, width: 0.95, size: 0.09 }, low: { x: 0.5, y: 0.7, width: 0.95, size: 0.07 } };
  // Repères d'alignement (fractions de la zone d'impression) et tolérance d'aimantation
  const GUIDES_X = [0.5];
  const GUIDES_Y = [0.1, 0.32, 0.5, 0.7];
  const SNAP = 0.02;

  // Détection d'écriture (mêmes plages que le serveur)
  const SCRIPT_RANGES = [
  ['latin', /[A-Za-z\u00C0-\u024F\u1E00-\u1EFF]/],
    ['cyrillic', /[\u0400-\u04FF]/],
    ['greek', /[\u0370-\u03FF\u1F00-\u1FFF]/],
    ['hebrew', /[\u0590-\u05FF\uFB1D-\uFB4F]/],
    ['arabic', /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/],
    ['devanagari', /[\u0900-\u097F]/],
    ['bengali', /[\u0980-\u09FF]/],
    ['thai', /[\u0E00-\u0E7F]/],
    ['han', /[\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F]/],
    ['kana', /[\u3040-\u30FF\uFF66-\uFF9F]/],
    ['hangul', /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/],
  ];
  const detectScripts = (t) => SCRIPT_RANGES.filter(([, re]) => re.test(t)).map(([n]) => n);
  const isRtl = (t) => detectScripts(t).some((s) => s === 'arabic' || s === 'hebrew');
  const SCRIPT_LANG = { arabic: 'ar', hebrew: 'he', cyrillic: 'ru', greek: 'el', han: 'zh', kana: 'ja', hangul: 'ko', devanagari: 'hi', bengali: 'bn', thai: 'th' };

  const canvas = root.querySelector('.vs__canvas');
  const ctx = canvas.getContext('2d');
  const q = (s) => root.querySelector(s);
  const els = {
    price: q('[data-vs-price]'), text: q('[data-vs-text]'), font: q('[data-vs-font]'), lang: q('[data-vs-lang]'),
    bold: q('[data-vs-bold]'), italic: q('[data-vs-italic]'), upper: q('[data-vs-upper]'),
    size: q('[data-vs-size]'), spacing: q('[data-vs-spacing]'), presets: root.querySelectorAll('[data-preset]'),
    image: q('[data-vs-image]'), imageLabel: q('[data-vs-image-label]'), imageSize: q('[data-vs-image-size]'), imageRemove: q('[data-vs-image-remove]'),
    posX: q('[data-vs-pos-x]'), posY: q('[data-vs-pos-y]'), centerX: q('[data-vs-center-x]'), centerY: q('[data-vs-center-y]'),
    target: q('[data-vs-target]'), error: q('[data-vs-error]'), submit: q('[data-vs-submit]'),
    sideTabs: root.querySelectorAll('[data-vs-side]'), backNote: q('[data-vs-back-note]'),
    ai: q('[data-vs-ai]'), aiPrompt: q('[data-vs-ai-prompt]'), aiStyles: q('[data-vs-ai-styles]'), aiNoLiving: q('[data-vs-ai-noliving]'),
    aiGo: q('[data-vs-ai-go]'), aiStatus: q('[data-vs-ai-status]'), aiResults: q('[data-vs-ai-results]'), aiQuota: q('[data-vs-ai-quota]'),
    aiPhoto: q('[data-vs-ai-photo]'), aiPhotoLabel: q('[data-vs-ai-photo-label]'),
    wizard: q('[data-vs-wizard]'), wizPrompt: q('[data-vs-wizard-prompt]'), wizNoLiving: q('[data-vs-wizard-noliving]'), wizGo: q('[data-vs-wizard-go]'),
    wizStatus: q('[data-vs-wizard-status]'), proposals: q('[data-vs-proposals]'),
    motif: q('[data-vs-motif]'), motifPrompt: q('[data-vs-motif-prompt]'), motifNoLiving: q('[data-vs-motif-noliving]'), motifGo: q('[data-vs-motif-go]'),
    motifStatus: q('[data-vs-motif-status]'), motifFile: q('[data-vs-motif-file]'), motifFileLabel: q('[data-vs-motif-file-label]'), motifScale: q('[data-vs-motif-scale]'),
    motifMirror: q('[data-vs-motif-mirror]'), imageField: q('[data-vs-image-field]'), aiField: q('[data-vs-ai]'), textStep: q('[data-vs-text-step]'),
  };

  const blankSide = (preset) => ({
    text: { type: 'text', text: '', font: 'bodonimoda', color: 'cafe', letterSpacing: 0, bold: false, italic: false, upper: false, align: 'center', ...preset },
    image: null,
  });

  const state = {
    config: null,
    lang: ['fr','en','es','de','it','ar'].includes(root.dataset.locale) ? root.dataset.locale : 'fr',
    color: root.querySelector('input[name="vs-color"]:checked')?.value,
    size: root.querySelector('input[name="vs-size"]:checked')?.value,
    side: 'front',
    sides: Object.fromEntries(AOP_PANELS.map((panel) => [panel, blankSide(panel === 'front' ? PRESETS.chest : PRESETS.center)])),
    get text() { return this.sides[this.side].text; },
    get image() { return this.sides[this.side].image; },
    set image(v) { this.sides[this.side].image = v; },
    selected: 'text',
    template: null,
    area: null,
    guides: null, // repères actifs pendant un déplacement { x?: number, y?: number }
    aop: false,
    pattern: null, // { ai?, data?, img, scale, mirror, background }
    busy: false,
    loadedLangs: new Set(),
  };

  root.querySelectorAll('.vs__swatch').forEach((sw) => {
    sw.style.setProperty('--sw', GARMENT[sw.querySelector('input').value.toLowerCase()] || '#CFC5B4');
  });

  const currentVariant = () => productData.variants.find((v) => (state.color ? v.color === state.color : true) && (state.size ? v.size === state.size : true));
  const variantKey = () => (state.color && state.size ? `${state.color}|${state.size}` : (state.color || state.size));
  const variantConfig = () => state.config?.variants[variantKey()];
  const selectedLayer = () => (state.selected === 'image' && state.image ? state.image : state.text);
  const layers = () => [state.image, state.text.text.trim() ? state.text : null].filter(Boolean);
  const displayText = (layer) => (layer.upper ? layer.text.toUpperCase() : layer.text);
  const clamp01 = (v) => Math.min(1, Math.max(0, v));

  function showError(msg) {
    els.error.textContent = msg || '';
    els.error.hidden = !msg;
  }

  // --- Configuration, langues, polices
  async function loadConfig() {
    const r = await fetch(`${BACKEND}/api/config/${PRODUCT}`);
    if (!r.ok) throw new Error(T('js_unavailable'));
    state.config = await r.json();
    for (const [key, f] of Object.entries(state.config.fonts)) { FONT_FAMILY[key] = f.family; FONT_LABEL[key] = f.label; }
    buildLangSelect(state.config);
    buildFontSelect(state.config);
    if (state.config.type === 'embroidery') {
      // broderie : texte seul, couleurs = fils Printful, une face
      state.embroidery = true;
      if (els.imageField) els.imageField.hidden = true;
      if (els.aiField) els.aiField.hidden = true;
      // la broderie en tête ; l'assistant IA reste disponible, replié, en second
      const emb = root.querySelector('[data-vs-embroidery]');
      if (emb) { emb.hidden = false; if (els.wizard) els.wizard.parentNode.insertBefore(emb, els.wizard); }
      if (els.wizard) { els.wizard.open = false; els.wizard.classList.add('vs__wizard--secondary'); const sum = els.wizard.querySelector('summary'); if (sum) sum.innerHTML = `<span class="vs__wizard-eyebrow">${T('wizard_eyebrow')}</span>${T('emb_ai')}`; }
      root.querySelectorAll('[data-emb-example]').forEach((b) => b.addEventListener('click', () => { els.text.value = b.dataset.embExample; els.text.dispatchEvent(new Event('input', { bubbles: true })); root.querySelector('.vs__stage')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }));
      els.sideTabs.forEach((b) => { b.style.display = 'none'; });
      const inks = root.querySelector('[data-vs-ink]');
      if (inks && state.config.threads) {
        Object.assign(INK, state.config.threads);
        inks.innerHTML = ''; inks.classList.add('vs__threads');
        for (const [key, hex] of Object.entries(state.config.threads)) {
          const l = document.createElement('label'); l.className = 'vs__thread'; l.style.setProperty('--ink', hex);
          l.innerHTML = `<input type="radio" name="vs-ink" value="${key}"><i></i><span>${T('thread_' + key)}</span>`;
          l.querySelector('input').addEventListener('change', () => { state.text.color = key; draw(); });
          inks.appendChild(l);
        }
        state.text.color = 'noir';
        autoInk();
      }
      Object.assign(state.sides.front.text, PRESETS.center, { y: 0.5, size: 0.42, width: 0.95 });
      els.size.value = String(state.sides.front.text.size); els.size.max = '0.8';
      els.presets.forEach((b) => { b.style.display = 'none'; });
    }
    if (state.config.type !== 'embroidery' && state.config.colors) {
      // palette d'encres servie par le studio (28 couleurs) : remplace la liste de secours du gabarit
      Object.assign(INK, state.config.colors);
      Object.assign(INK_NAMES, state.config.ink_labels || {});
      const inks = root.querySelector('[data-vs-ink]');
      if (inks) {
        inks.innerHTML = '';
        for (const [key, hex] of Object.entries(state.config.colors)) {
          const l = document.createElement('label'); l.className = 'vs__ink'; l.style.setProperty('--ink', hex);
          const label = key.replace(/-/g, ' ').replace(/^./, (ch) => ch.toUpperCase());
          l.innerHTML = `<input type="radio" name="vs-ink" value="${key}"${key === state.text.color ? ' checked' : ''}><span class="visually-hidden">${label}</span>`;
          l.title = label;
          l.querySelector('input').addEventListener('change', () => { state.text.color = key; draw(); });
          inks.appendChild(l);
        }
      }
    }
    if (state.config.type === 'aop') {
      state.aop = true;
      if (els.motif) { els.motif.hidden = false; if (els.textStep) els.textStep.parentNode.insertBefore(els.motif, els.textStep); }
      if (els.textStep) {
        els.textStep.classList.add('vs__step--optional'); els.textStep.open = false;
        const posField = root.querySelector('[data-vs-target]')?.closest('fieldset');
        if (posField) els.textStep.appendChild(posField); // la position fine ne concerne que le texte
      }
      // visuel posé : le client peut coller une illustration sur un panneau, en plus ou à la place du motif
      const placed = Boolean(state.config.placed_graphics);
      if (els.imageField) els.imageField.hidden = !placed;
      if (els.aiField) els.aiField.hidden = !placed;
      if (els.wizard) els.wizard.style.display = placed ? '' : 'none'; // sinon, sur l'all-over, l'IA c'est le motif
      els.presets.forEach((b) => { if (b.dataset.preset === 'chest') b.style.display = 'none'; });
      state.pattern = { img: null, scale: 0.3, mirror: true, background: '#ffffff' };
      if (state.config.example) loadExamplePattern(state.config.example);
      if (state.config.knit && els.motif && !root.querySelector('.vs__knit-note')) {
        const n = document.createElement('p'); n.className = 'vs__knit-note'; n.textContent = T('js_knit_note');
        els.motif.insertBefore(n, els.motif.firstChild?.nextSibling || null);
      }
      if (els.backNote) { els.backNote.textContent = T('js_back_included'); els.backNote.hidden = false; }
      // un onglet par panneau réellement imprimable : capuche et manches n'existent que sur certains vêtements
      const firstCfg = Object.values(state.config.variants || {})[0];
      let shown = 0;
      els.sideTabs.forEach((b) => {
        const panel = b.dataset.vsSide;
        const available = panel === 'front' || Boolean(firstCfg?.sides?.[panel]);
        b.hidden = !available;
        if (available) shown++;
      });
      if (shown <= 1) { // pièce unique (leggings) : l'onglet seul n'apporte rien
        els.sideTabs.forEach((b) => { b.hidden = true; });
        if (els.backNote) els.backNote.hidden = true;
      }
      Object.assign(state.sides.front.text, PRESETS.center); els.size.value = String(state.sides.front.text.size);
    }
  }

  function buildLangSelect(config) {
    els.lang.innerHTML = '';
    const groups = config.language_groups || {};
    const byGroup = {};
    for (const [code, l] of Object.entries(config.languages || {})) (byGroup[l.group || 'autres'] ||= []).push([code, l]);
    for (const [g, list] of Object.entries(byGroup)) {
      const og = document.createElement('optgroup');
      og.label = groups[g] || g;
      for (const [code, l] of list) {
        const o = document.createElement('option');
        o.value = code; o.textContent = l.label;
        og.appendChild(o);
      }
      els.lang.appendChild(og);
    }
    els.lang.value = state.lang;
  }

  // Polices d'une langue : écriture principale compatible (pas de police arabe dans la liste française) et couverture complète
  function fontsForLang(config, lang) {
    const l = config.languages?.[lang] || { mains: ['latin'], scripts: ['latin'] };
    return Object.entries(config.fonts).filter(([, f]) => (!l.mains || l.mains.includes(f.main)) && l.scripts.every((s) => f.scripts.includes(s)));
  }

  function buildFontSelect(config) {
    const groups = config.font_groups || {};
    const prefer = config.languages?.[state.lang]?.prefer || [];
    const list = fontsForLang(config, state.lang).sort(([a], [b]) => prefer.indexOf(b) - prefer.indexOf(a));
    const byGroup = {};
    for (const [key, f] of list) (byGroup[f.group || 'autres'] ||= []).push([key, f]);
    els.font.innerHTML = '';
    for (const g of ['calligraphy', 'elegant', 'modern', 'artistic', 'autres']) {
      if (!byGroup[g]) continue;
      const og = document.createElement('optgroup');
      og.label = `${groups[g] || g} (${byGroup[g].length})`;
      for (const [key, f] of byGroup[g]) {
        const o = document.createElement('option');
        o.value = key; o.textContent = f.label; o.style.fontFamily = `"${f.family}"`;
        og.appendChild(o);
      }
      els.font.appendChild(og);
    }
    if (!list.some(([k]) => k === state.text.font)) state.text.font = list[0]?.[0] || 'jost';
    els.font.value = state.text.font;
    loadWebFonts(list);
    document.fonts.load(`16px "${FONT_FAMILY[state.text.font]}"`).then(draw).catch(draw);
  }

  // Les fichiers Google Fonts ne sont chargés que pour la langue affichée (les mêmes fichiers servent au rendu serveur)
  function loadWebFonts(list) {
    if (state.loadedLangs.has(state.lang)) return;
    state.loadedLangs.add(state.lang);
    const families = list.map(([, f]) => f.google).filter(Boolean);
    for (let i = 0; i < families.length; i += 25) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?${families.slice(i, i + 25).map((f) => `family=${f}`).join('&')}&display=swap`;
      document.head.appendChild(link);
    }
  }

  function syncLangToText() {
    const scripts = detectScripts(state.text.text);
    const other = scripts.find((s) => s !== 'latin');
    const lang = other ? (other === 'han' && scripts.includes('kana') ? 'ja' : SCRIPT_LANG[other]) : null;
    if (lang && lang !== state.lang && state.config?.languages?.[lang]) {
      state.lang = lang; els.lang.value = lang; buildFontSelect(state.config);
    }
  }

  // --- Gabarit
  async function loadTemplate() {
    const variant = variantConfig();
    const v = variant?.sides?.[state.side] || (state.side === 'front' ? variant : null);
    if (!v) { state.template = null; state.area = null; draw(); return; }
    const s = canvas.width / v.size;
    state.area = { x: v.area.x * s, y: v.area.y * s, w: v.area.w * s, h: v.area.h * s, bg: v.background };
    // vêtement en deux pièces (robe, bikini) : chaque pièce reçoit le motif à sa propre échelle, le texte reste sur la pièce principale
    state.pieces = Array.isArray(v.pieces) ? v.pieces.map((r) => ({ x: r.x * s, y: r.y * s, w: r.w * s, h: r.h * s })) : null;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = v.template;
    let bgImg = null;
    if (v.background_image) { bgImg = new Image(); bgImg.crossOrigin = 'anonymous'; bgImg.src = v.background_image; }
    await Promise.all([img.decode().catch(() => {}), bgImg ? bgImg.decode().catch(() => {}) : null]);
    state.template = img;
    state.templateBg = bgImg && bgImg.naturalWidth ? bgImg : null;
    draw();
  }

  // --- Rendu (même modèle que le backend : coordonnées normalisées dans la zone d'impression)
  const fontSpec = (layer, px) => `${layer.italic ? 'italic' : 'normal'} ${layer.bold ? '700' : '400'} ${px}px "${FONT_FAMILY[layer.font]}"`;

  function wrapLines(text, maxWidth) {
    const out = [];
    for (const raw of text.split('\n')) {
      const words = raw.split(/\s+/).filter(Boolean);
      if (!words.length) { out.push(''); continue; }
      let line = words[0];
      for (const w of words.slice(1)) {
        const t = `${line} ${w}`;
        if (ctx.measureText(t).width <= maxWidth) line = t; else { out.push(line); line = w; }
      }
      out.push(line);
    }
    return out;
  }

  /** Même règle que le serveur (fitText) : espacement compris dans la mesure, police réduite si une ligne dépasse la zone d'impression. */
  function fitLayer(layer, area) {
    let px = layer.size * area.h;
    let lines = [];
    ctx.save();
    for (let i = 0; i < 6; i++) {
      ctx.font = fontSpec(layer, px);
      if ('letterSpacing' in ctx) ctx.letterSpacing = `${layer.letterSpacing * px}px`;
      lines = wrapLines(displayText(layer), layer.width * area.w);
      const widest = Math.max(1, ...lines.map((l) => ctx.measureText(l).width));
      if (widest <= area.w * 0.98 || px < 6) break;
      px *= (area.w * 0.98 / widest) * 0.98;
    }
    const w = Math.max(1, ...lines.map((l) => ctx.measureText(l).width));
    ctx.restore();
    return { px, lines, w };
  }

  /** Boîte englobante d'un calque, en pixels canvas. */
  function layerBox(layer) {
    const a = state.area;
    const cx = a.x + layer.x * a.w;
    const cy = a.y + layer.y * a.h;
    if (layer.type === 'text') {
      const { px, lines, w } = fitLayer(layer, a);
      const h = px * 1.15 * lines.length;
      return { x: cx - w / 2, y: cy - h / 2, w, h, cx, cy };
    }
    const w = layer.width * a.w;
    const h = w * (layer.img.height / layer.img.width);
    return { x: cx - w / 2, y: cy - h / 2, w, h, cx, cy };
  }

  function tilePattern(cx, area, img, scale, mirror) {
    const tw = Math.max(8, area.w * scale); const th = tw * (img.height / img.width);
    cx.save(); cx.beginPath(); cx.rect(area.x, area.y, area.w, area.h); cx.clip();
    const cols = Math.ceil(area.w / tw) + 1, rows = Math.ceil(area.h / th) + 1;
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      cx.save(); cx.translate(area.x + c * tw + tw / 2, area.y + r * th + th / 2);
      if (mirror) cx.scale(c % 2 ? -1 : 1, r % 2 ? -1 : 1);
      cx.drawImage(img, -tw / 2, -th / 2, tw, th); cx.restore();
    }
    cx.restore();
  }

  const offscreen = document.createElement('canvas');
  function garmentCanvas(W, H) {
    offscreen.width = W; offscreen.height = H;
    const g = offscreen.getContext('2d');
    g.fillStyle = state.area?.bg ? `#${state.area.bg.replace('#', '')}` : '#ffffff';
    g.fillRect(0, 0, W, H);
    if (state.templateBg) g.drawImage(state.templateBg, 0, 0, W, H); // ordre Printful : couleur, fond (texture ou corps du vêtement), image
    g.drawImage(state.template, 0, 0, W, H);
    return offscreen;
  }

  // Broderie : rendu « point satin » du texte (hachures fines + léger relief), aperçu seulement
  function stitchText(ctx, px, drawFn) {
    if (!state.embroidery) { drawFn(ctx); return; }
    const W = ctx.canvas.width, H = ctx.canvas.height;
    const off = document.createElement('canvas'); off.width = W; off.height = H;
    const oc = off.getContext('2d');
    const m = ctx.getTransform(); oc.setTransform(m);
    oc.shadowColor = 'rgba(0,0,0,0.35)'; oc.shadowBlur = px * 0.05; oc.shadowOffsetY = px * 0.025;
    drawFn(oc);
    oc.shadowColor = 'transparent';
    oc.setTransform(1, 0, 0, 1, 0, 0); oc.globalCompositeOperation = 'source-atop'; oc.lineWidth = Math.max(1, px * 0.012);
    const step = Math.max(2.5, px * 0.05);
    for (let x = -H, i = 0; x < W + H; x += step, i++) { oc.strokeStyle = i % 2 ? 'rgba(255,255,255,0.32)' : 'rgba(0,0,0,0.3)'; oc.beginPath(); oc.moveTo(x, 0); oc.lineTo(x + H, H); oc.stroke(); }
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(off, 0, 0); ctx.restore();
  }

  /** Zones de tissu d'un gabarit : pixels transparents (gabarits découpés) ou, pour un gabarit dessiné au trait sur fond blanc,
   *  zones claires enfermées par le contour (celles qui touchent le bord de l'image sont le fond). */
  function fabricZones(d, W, H) {
    const inside = new Uint8Array(W * H);
    let transparent = 0;
    for (let k = 0; k < W * H; k++) if (d[k * 4 + 3] === 0) { inside[k] = 1; transparent++; }
    if (transparent > W * H * 0.01) return inside;
    const light = (k) => { const i = k * 4; return (d[i] + d[i + 1] + d[i + 2]) / 3 > 245; };
    // un trait fin réduit à l'échelle devient gris clair : on épaissit le contour d'un pixel pour qu'il reste fermé
    for (let k = 0; k < W * H; k++) { const x = k % W; inside[k] = light(k) && (x === 0 || light(k - 1)) && (x === W - 1 || light(k + 1)) && (k < W || light(k - W)) && (k >= W * (H - 1) || light(k + W)) ? 1 : 0; }
    const seen = new Uint8Array(W * H); const stack = [];
    const push = (k) => { if (inside[k] && !seen[k]) { seen[k] = 1; stack.push(k); } };
    for (let x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
    for (let y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
    while (stack.length) {
      const k = stack.pop(); const x = k % W;
      if (x > 0) push(k - 1); if (x < W - 1) push(k + 1); if (k >= W) push(k - W); if (k < W * (H - 1)) push(k + W);
    }
    for (let k = 0; k < W * H; k++) if (seen[k]) inside[k] = 0;
    return inside;
  }

  function panelMask(W, H) {
    if (state.panelMask && state.panelMask.width === W && state.panelMask.src === state.template) return state.panelMask;
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const x = c.getContext('2d');
    x.drawImage(state.template, 0, 0, W, H);
    let id;
    try { id = x.getImageData(0, 0, W, H); } catch { return c; }
    const d = id.data;
    const keep = largeComponents(fabricZones(d, W, H), W, H); // gabarit découpé ou dessiné au trait
    for (let k = 0; k < W * H; k++) { const i = k * 4; d[i] = 242; d[i + 1] = 232; d[i + 2] = 213; d[i + 3] = keep[k] ? 255 : 0; }
    x.putImageData(id, 0, 0);
    const closed = closeMask(c, Math.max(2, Math.round(W / 220)));
    closed.src = state.template; state.panelMask = closed;
    return closed;
  }


  function fillHoles(keep, W, H) {
    const outside = new Uint8Array(W * H); const stack = [];
    const push = (i) => { if (!keep[i] && !outside[i]) { outside[i] = 1; stack.push(i); } };
    for (let x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
    for (let y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
    while (stack.length) {
      const i = stack.pop(); const x = i % W;
      if (x > 0) push(i - 1); if (x < W - 1) push(i + 1); if (i >= W) push(i - W); if (i < W * (H - 1)) push(i + W);
    }
    const out = new Uint8Array(W * H);
    for (let k = 0; k < W * H; k++) out[k] = outside[k] ? 0 : 1;
    return out;
  }

  /** Zones transparentes du gabarit assez grandes pour être du tissu : les traits de coupe et la ligne de sécurité découpent
   *  parfois le panneau en plusieurs zones ; on garde toutes celles d'au moins 8 % de la plus grande (légendes et bandes exclues). */
  function largeComponents(inside, W, H, ratio = 0.08) {
    const label = new Int32Array(W * H); const sizes = [0]; const stack = []; let cur = 0;
    for (let s = 0; s < W * H; s++) {
      if (!inside[s] || label[s]) continue;
      cur++; let size = 0; stack.push(s); label[s] = cur;
      while (stack.length) {
        const i = stack.pop(); size++; const x = i % W;
        if (x > 0 && inside[i - 1] && !label[i - 1]) { label[i - 1] = cur; stack.push(i - 1); }
        if (x < W - 1 && inside[i + 1] && !label[i + 1]) { label[i + 1] = cur; stack.push(i + 1); }
        if (i >= W && inside[i - W] && !label[i - W]) { label[i - W] = cur; stack.push(i - W); }
        if (i < W * (H - 1) && inside[i + W] && !label[i + W]) { label[i + W] = cur; stack.push(i + W); }
      }
      sizes.push(size);
    }
    let biggest = 0; for (const n of sizes) if (n > biggest) biggest = n; // pas de spread : des centaines de milliers de zones feraient déborder la pile
  const min = biggest * ratio;
    return label.map((v) => (v && sizes[v] >= min ? 1 : 0));
  }

  // ne garder que la plus grande composante connexe (le panneau ; bandes de pliage et légende exclues)
  function largestComponent(inside, W, H) {
    const label = new Int32Array(W * H); let best = 0, bestSize = 0, cur = 0;
    const stack = [];
    for (let s = 0; s < W * H; s++) {
      if (!inside[s] || label[s]) continue;
      cur++; let size = 0; stack.push(s); label[s] = cur;
      while (stack.length) {
        const i = stack.pop(); size++;
        const x = i % W, y = (i - x) / W;
        const nb = [i - 1, i + 1, i - W, i + W];
        for (let k = 0; k < 4; k++) {
          const j = nb[k];
          if (j < 0 || j >= W * H) continue;
          if ((k === 0 && x === 0) || (k === 1 && x === W - 1)) continue;
          if (inside[j] && !label[j]) { label[j] = cur; stack.push(j); }
        }
      }
      if (size > bestSize) { bestSize = size; best = cur; }
    }
    return label.map((v) => (v === best ? 1 : 0));
  }

  function closeMask(mask, r) {
    // fermeture morphologique : comble pointillés et traits fins du gabarit
    const W = mask.width, H = mask.height, offsets = [];
    for (let dx = -r; dx <= r; dx += r) for (let dy = -r; dy <= r; dy += r) offsets.push([dx, dy]);
    const dil = document.createElement('canvas'); dil.width = W; dil.height = H; const dc = dil.getContext('2d');
    for (const [dx, dy] of offsets) dc.drawImage(mask, dx, dy);
    const out = document.createElement('canvas'); out.width = W; out.height = H; const oc = out.getContext('2d');
    oc.drawImage(dil, 0, 0); oc.globalCompositeOperation = 'destination-in';
    for (const [dx, dy] of offsets) oc.drawImage(dil, dx, dy);
    return out;
  }

  // Tricot : aperçu en mailles (grille de la taille réelle, 4 fils au plus de la palette Printful), comme le fichier envoyé à l'atelier
  const hexRgb = (h) => { const n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
  const dist2 = (a, b) => { const rm = (a[0] + b[0]) / 2, dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2]; return (2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db; };
  function knitify(cx, area, knit) {
    const cols = Math.max(40, Math.round(knit.cols || 480)), rows = Math.max(40, Math.round(cols * area.h / area.w));
    const low = document.createElement('canvas'); low.width = cols; low.height = rows;
    const lc = low.getContext('2d'); lc.imageSmoothingEnabled = true;
    lc.drawImage(cx.canvas, area.x, area.y, area.w, area.h, 0, 0, cols, rows);
    const id = lc.getImageData(0, 0, cols, rows); const d = id.data;
    const pal = knit.yarns.map(hexRgb); const votes = new Array(pal.length).fill(0);
    const near = (p, list) => { let b = 0, bd = Infinity; for (let i = 0; i < list.length; i++) { const x = dist2(p, list[i]); if (x < bd) { bd = x; b = i; } } return b; };
    for (let i = 0; i < d.length; i += 16) votes[near([d[i], d[i + 1], d[i + 2]], pal)]++;
    const chosen = [];
    for (const [, i] of votes.map((v, i) => [v, i]).filter(([v]) => v).sort((a, b) => b[0] - a[0])) {
      if (chosen.length >= knit.max_yarns) break;
      if (chosen.every((j) => dist2(pal[i], pal[j]) > 2500)) chosen.push(i);
    }
    const use = chosen.map((i) => pal[i]);
    for (let i = 0; i < d.length; i += 4) { const c = use[near([d[i], d[i + 1], d[i + 2]], use)]; d[i] = c[0]; d[i + 1] = c[1]; d[i + 2] = c[2]; d[i + 3] = 255; }
    lc.putImageData(id, 0, 0);
    cx.save(); cx.setTransform(1, 0, 0, 1, 0, 0); cx.imageSmoothingEnabled = false;
    cx.drawImage(low, area.x, area.y, area.w, area.h); cx.restore();
  }

  function draw() {
    const { width: W, height: H } = canvas;
    ctx.clearRect(0, 0, W, H);
    if (!(state.aop && state.template)) { ctx.fillStyle = '#F2E8D5'; ctx.fillRect(0, 0, W, H); }
    if (state.aop && state.area) {
      for (const zone of state.pieces || [state.area]) {
        ctx.fillStyle = state.pattern?.background || '#ffffff';
        ctx.fillRect(zone.x, zone.y, zone.w, zone.h);
        if (state.pattern?.img) tilePattern(ctx, zone, state.pattern.img, state.pattern.scale, state.pattern.mirror);
      }
      if (state.config?.knit) knitify(ctx, state.area, state.config.knit);
    } else if (state.template) {
      // vêtement composé sur sa couleur (gabarits-masques Printful), puis multiply : le blanc devient ivoire
      const g = garmentCanvas(W, H);
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(g, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
    }
    if (!state.area) return;
    const a = state.area;
    ctx.save();
    ctx.setLineDash([12, 10]);
    ctx.strokeStyle = 'rgba(43,33,28,0.28)';
    ctx.lineWidth = 2;
    ctx.strokeRect(a.x, a.y, a.w, a.h);
    ctx.restore();
    if (state.guides) {
      ctx.save();
      ctx.setLineDash([6, 6]);
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgba(178,58,46,0.85)';
      if (state.guides.x != null) { ctx.beginPath(); ctx.moveTo(a.x + state.guides.x * a.w, a.y); ctx.lineTo(a.x + state.guides.x * a.w, a.y + a.h); ctx.stroke(); }
      if (state.guides.y != null) { ctx.beginPath(); ctx.moveTo(a.x, a.y + state.guides.y * a.h); ctx.lineTo(a.x + a.w, a.y + state.guides.y * a.h); ctx.stroke(); }
      ctx.restore();
    }
    for (const layer of layers()) {
      ctx.save();
      ctx.translate(a.x + layer.x * a.w, a.y + layer.y * a.h);
      if (layer.type === 'text') {
        const { px, lines } = fitLayer(layer, a);
        ctx.font = fontSpec(layer, px);
        ctx.fillStyle = INK[layer.color];
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.direction = isRtl(layer.text) ? 'rtl' : 'ltr';
        if ('letterSpacing' in ctx) ctx.letterSpacing = `${layer.letterSpacing * px}px`;
        const lh = px * 1.15;
        const total = lh * (lines.length - 1);
        stitchText(ctx, px, (c) => { if (c !== ctx) { c.font = ctx.font; c.fillStyle = ctx.fillStyle; c.textBaseline = 'middle'; c.textAlign = 'center'; c.direction = ctx.direction; if ('letterSpacing' in c) c.letterSpacing = ctx.letterSpacing; } lines.forEach((line, i) => c.fillText(line, 0, -total / 2 + i * lh)); });
      } else if (layer.img) {
        const w = layer.width * a.w;
        const h = w * (layer.img.height / layer.img.width);
        ctx.drawImage(layer.img, -w / 2, -h / 2, w, h);
      }
      ctx.restore();
    }
    if (state.aop && state.template) {
      // découpe à la silhouette du panneau (zone transparente du gabarit), ombre légère, fond ivoire
      const mask = panelMask(W, H);
      ctx.globalCompositeOperation = 'destination-in'; ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'destination-over';
      ctx.save(); ctx.shadowColor = 'rgba(43,33,28,0.22)'; ctx.shadowBlur = W * 0.025; ctx.shadowOffsetY = W * 0.008; ctx.drawImage(mask, 0, 0); ctx.restore();
      ctx.fillStyle = '#F2E8D5'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over';
    }
    const sel = selectedLayer();
    if (sel && layers().includes(sel)) {
      const b = layerBox(sel);
      ctx.save();
      ctx.strokeStyle = 'rgba(46,90,62,0.9)';
      ctx.lineWidth = 2;
      ctx.setLineDash([]);
      ctx.strokeRect(b.x - 10, b.y - 8, b.w + 20, b.h + 16);
      ctx.restore();
    }
    syncPositionInputs();
  }

  // --- Position précise (champs X / Y, centrage, clavier)
  function syncPositionInputs() {
    const l = selectedLayer();
    if (!els.posX) return;
    els.posX.value = Math.round(l.x * 100);
    els.posY.value = Math.round(l.y * 100);
    if (els.target) els.target.textContent = state.selected === 'image' && state.image ? T('js_image') : T('js_text');
  }

  function moveSelected(dx, dy) {
    const l = selectedLayer();
    l.x = clamp01(l.x + dx);
    l.y = clamp01(l.y + dy);
    draw();
  }

  function setSelected(kind) {
    state.selected = kind === 'image' && state.image ? 'image' : 'text';
    draw();
  }

  els.posX?.addEventListener('input', () => { selectedLayer().x = clamp01(Number(els.posX.value) / 100); draw(); });
  els.posY?.addEventListener('input', () => { selectedLayer().y = clamp01(Number(els.posY.value) / 100); draw(); });
  els.centerX?.addEventListener('click', () => { selectedLayer().x = 0.5; draw(); });
  els.centerY?.addEventListener('click', () => { selectedLayer().y = 0.5; draw(); });
  canvas.addEventListener('keydown', (e) => {
    const step = e.shiftKey ? 0.02 : 0.005;
    const map = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
    if (!map[e.key]) return;
    e.preventDefault();
    moveSelected(...map[e.key]);
  });

  // --- Déplacement au doigt / à la souris, avec aimantation aux repères
  let drag = null;
  function toCanvas(e) {
    const r = canvas.getBoundingClientRect();
    return { x: ((e.clientX - r.left) / r.width) * canvas.width, y: ((e.clientY - r.top) / r.height) * canvas.height };
  }
  function hitLayer(p) {
    let best = null;
    for (const layer of layers()) {
      const b = layerBox(layer);
      const inside = p.x >= b.x - 20 && p.x <= b.x + b.w + 20 && p.y >= b.y - 20 && p.y <= b.y + b.h + 20;
      if (!inside) continue;
      const d = Math.hypot(b.cx - p.x, b.cy - p.y);
      if (!best || d < best.d) best = { layer, d };
    }
    return best?.layer || null;
  }
  canvas.addEventListener('pointerdown', (e) => {
    if (!state.area) return;
    const p = toCanvas(e);
    const layer = hitLayer(p);
    canvas.focus({ preventScroll: true }); // sans défilement : toucher l’aperçu épinglé ne doit pas faire sauter la page
    if (!layer) return;
    state.selected = layer.type === 'image' ? 'image' : 'text';
    drag = { layer, start: p, ox: layer.x, oy: layer.y };
    canvas.setPointerCapture(e.pointerId);
    e.preventDefault();
    draw();
  });
  canvas.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const p = toCanvas(e);
    const a = state.area;
    let x = clamp01(drag.ox + (p.x - drag.start.x) / a.w);
    let y = clamp01(drag.oy + (p.y - drag.start.y) / a.h);
    const other = layers().find((l) => l !== drag.layer);
    const gx = [...GUIDES_X, ...(other ? [other.x] : [])];
    const gy = [...GUIDES_Y, ...(other ? [other.y] : [])];
    const guides = {};
    for (const g of gx) if (Math.abs(x - g) < SNAP) { x = g; guides.x = g; break; }
    for (const g of gy) if (Math.abs(y - g) < SNAP) { y = g; guides.y = g; break; }
    drag.layer.x = x; drag.layer.y = y;
    state.guides = Object.keys(guides).length ? guides : null;
    draw();
  });
  const endDrag = () => { drag = null; state.guides = null; draw(); };
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);

  // --- Recto / verso
  const sideHasContent = (side) => Boolean(state.sides[side].text.text.trim() || state.sides[side].image);
  function syncControlsToSide() {
    const t = state.text;
    els.text.value = t.text;
    els.size.value = String(t.size); els.spacing.value = String(t.letterSpacing);
    els.bold.setAttribute('aria-pressed', String(t.bold)); els.italic.setAttribute('aria-pressed', String(t.italic)); els.upper.setAttribute('aria-pressed', String(t.upper));
    const ink = root.querySelector(`input[name="vs-ink"][value="${t.color}"]`); if (ink) ink.checked = true;
    if (state.config) buildFontSelect(state.config);
    els.imageSize.hidden = !state.image; if (els.imageRemove) els.imageRemove.hidden = !state.image;
    if (state.image) els.imageSize.querySelector('input').value = String(state.image.width); // taille propre à la face
    els.imageLabel.textContent = state.image ? (state.image.preset ? T('js_preset_logo') : T('js_ai_placed')) : T('upload');
    els.sideTabs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vsSide === state.side)));
    // état des boutons d'emplacement selon la position du texte de la face
    const preset = Object.entries(PRESETS).find(([, p]) => Math.abs(p.x - t.x) < 0.01 && Math.abs(p.y - t.y) < 0.01)?.[0];
    els.presets.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.preset === preset)));
    if (els.backNote && !state.aop) els.backNote.hidden = !sideHasContent('back');
    state.selected = 'text';
  }
  els.sideTabs.forEach((b) => b.addEventListener('click', () => {
    if (state.side === b.dataset.vsSide) return;
    state.side = b.dataset.vsSide;
    syncControlsToSide();
    loadTemplate();
  }));

  // --- Contrôles
  // --- Logo Verso par défaut : posé sur le devant tant que le client n'a rien ajouté, café sur clair / ivoire sur foncé.
  // Le client peut le garder (commande « Verso par défaut »), le remplacer par son image ou le retirer.
  const LOGO_SRC = { light: root.dataset.logoLight, dark: root.dataset.logoDark };
  const LOGO_LAYOUT = { x: 0.5, y: 0.28, width: 0.3 };
  const logoCache = {};
  async function logoLayer(tone) {
    if (!logoCache[tone]) {
      const img = new Image(); img.src = LOGO_SRC[tone];
      await img.decode();
      const c = document.createElement('canvas'); c.width = img.width; c.height = img.height; c.getContext('2d').drawImage(img, 0, 0);
      logoCache[tone] = { img, data: c.toDataURL('image/png') };
    }
    return { type: 'image', preset: tone, ...logoCache[tone], ...LOGO_LAYOUT };
  }
  async function applyPresetLogo() {
    if (!state.config || state.aop || state.embroidery || !LOGO_SRC.light || !LOGO_SRC.dark) return; // attend la configuration : jamais sur un all-over ni une broderie
    const front = state.sides.front;
    if (front.image && !front.image.preset) return; // image du client : on ne touche pas
    // le logo par défaut n'est qu'un point de départ : jamais remis après une proposition, un retrait ou dès que le client a écrit son texte
    if (!front.image && (state.presetDismissed || (front.text?.text || '').trim())) return;
    const tone = DARK.includes((state.color || '').toLowerCase()) ? 'dark' : 'light';
    if (front.image && front.image.preset === tone) return;
    try {
      const keepLayout = front.image ? { x: front.image.x, y: front.image.y, width: front.image.width } : {};
      front.image = { ...(await logoLayer(tone)), ...keepLayout };
    } catch { return; } // logo indisponible : la fiche reste vide, le client ajoute son contenu
    if (state.side === 'front') syncControlsToSide();
    draw();
  }

  // IA indisponible (crédits, panne) : message clair et boutons IA désactivés ; texte, image et motifs de la bibliothèque restent utilisables
  async function checkAiStatus() {
    try {
      const r = await fetch(`${BACKEND}/api/ai/status`, { cache: 'no-store' });
      if (!r.ok) return;
      const st = await r.json();
      if (st.available) return;
      if (!root.querySelector('.vs__ai-down')) {
        const note = document.createElement('p'); note.className = 'vs__ai-down'; note.setAttribute('role', 'status'); note.textContent = T('js_ai_down');
        const panel = root.querySelector('.vs__panel'); const title = panel?.querySelector('.vs__price');
        if (title) title.insertAdjacentElement('afterend', note);
      }
      [els.wizGo, els.aiGo, els.motifGo].forEach((b) => { if (b) { b.disabled = true; b.title = T('js_ai_down'); } });
      if (els.wizard) els.wizard.open = false;
    } catch { /* statut inconnu : on laisse l'IA active, l'appel réel signalera l'erreur */ }
  }

  function autoInk() {
    const dark = DARK.includes((state.color || '').toLowerCase());
    if (state.embroidery) { // fil contrasté avec la casquette
      if (dark && ['noir', 'marine', 'bordeaux'].includes(state.text.color)) state.text.color = 'blanc';
      if (!dark && ['blanc', 'or', 'gris'].includes(state.text.color)) state.text.color = 'noir';
      const r = root.querySelector(`input[name="vs-ink"][value="${state.text.color}"]`);
      if (r) r.checked = true;
      return;
    }
    const lum = (hex) => { const n = parseInt(String(hex || '#000').replace('#', ''), 16); const f = (c) => { const v = c / 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }; return 0.2126 * f((n >> 16) & 255) + 0.7152 * f((n >> 8) & 255) + 0.0722 * f(n & 255); };
    if (dark && lum(INK[state.text.color]) < 0.18) state.text.color = 'ivoire';
    if (!dark && lum(INK[state.text.color]) > 0.6) state.text.color = 'cafe';
    const r = root.querySelector(`input[name="vs-ink"][value="${state.text.color}"]`);
    if (r) r.checked = true;
  }
  root.querySelectorAll('input[name="vs-color"]').forEach((i) => i.addEventListener('change', () => { state.color = i.value; autoInk(); updatePrice(); loadTemplate(); applyPresetLogo(); }));
  root.querySelectorAll('input[name="vs-size"]').forEach((i) => i.addEventListener('change', () => { state.size = i.value; updatePrice(); loadTemplate(); }));
  applyPresetLogo();
  root.querySelectorAll('input[name="vs-ink"]').forEach((i) => i.addEventListener('change', () => { state.text.color = i.value; draw(); }));
  els.text.addEventListener('input', () => {
    state.text.text = els.text.value.slice(0, 120);
    // Pièce personnalisée : le logo Verso posé par défaut s'efface dès que le client écrit son propre texte.
    if ((state.text.text || '').trim() && state.sides.front.image?.preset) {
      state.sides.front.image = null;
      state.presetDismissed = true;
      if (state.side === 'front') { state.image = null; if (els.imageSize) els.imageSize.hidden = true; if (els.imageRemove) els.imageRemove.hidden = true; if (els.imageLabel) els.imageLabel.textContent = T('upload'); }
    }
    syncLangToText();
    if (els.backNote) els.backNote.hidden = !sideHasContent('back');
    setSelected('text');
  });
  els.lang.addEventListener('change', () => { state.lang = els.lang.value; buildFontSelect(state.config); draw(); });
  els.font.addEventListener('change', async () => {
    state.text.font = els.font.value;
    try { await document.fonts.load(`16px "${FONT_FAMILY[state.text.font]}"`); } catch { /* police de repli */ }
    draw();
  });
  els.size.addEventListener('input', () => { state.text.size = Number(els.size.value); draw(); });
  els.spacing.addEventListener('input', () => { state.text.letterSpacing = Number(els.spacing.value); draw(); });
  const toggle = (btn, key) => btn.addEventListener('click', () => {
    state.text[key] = !state.text[key];
    btn.setAttribute('aria-pressed', String(state.text[key]));
    draw();
  });
  toggle(els.bold, 'bold'); toggle(els.italic, 'italic'); toggle(els.upper, 'upper');
  els.presets.forEach((b) => b.addEventListener('click', () => {
    els.presets.forEach((x) => x.setAttribute('aria-pressed', 'false'));
    b.setAttribute('aria-pressed', 'true');
    const p = PRESETS[b.dataset.preset];
    Object.assign(state.text, p);
    els.size.value = String(state.text.size);
    if (state.image) {
      state.image.x = p.x;
      state.image.y = state.text.text.trim() ? Math.min(0.95, p.y + state.text.size * 2 + state.image.width * 0.5) : p.y;
    }
    draw();
  }));

  els.image.addEventListener('change', () => {
    const file = els.image.files[0];
    if (!file) return;
    if (file.size > 6 * 1024 * 1024) { showError(T('js_image_heavy')); els.image.value = ''; return; }
    const reader = new FileReader();
    reader.onload = async () => {
      const img = new Image();
      img.src = reader.result;
      await img.decode().catch(() => {});
      if (!img.width) { showError(T('js_image_unreadable')); return; }
      const width = Number(els.imageSize.querySelector('input').value);
      const hasText = Boolean(state.text.text.trim());
      state.image = { type: 'image', data: reader.result, img, x: hasText ? state.text.x : 0.5, y: hasText ? Math.min(0.9, state.text.y + 0.2) : 0.35, width };
      els.imageLabel.textContent = `${file.name} · ${T('js_image_placed')}`;
      els.imageSize.hidden = false;
      if (els.imageRemove) els.imageRemove.hidden = false;
      if (els.backNote) els.backNote.hidden = !sideHasContent('back');
      showError('');
      setSelected('image');
    };
    reader.readAsDataURL(file);
  });
  els.imageSize.querySelector('input').addEventListener('input', (e) => { if (state.image) { state.image.width = Number(e.target.value); draw(); } });
  els.imageRemove?.addEventListener('click', () => {
    state.image = null; state.presetDismissed = true; els.image.value = ''; els.imageSize.hidden = true; els.imageRemove.hidden = true;
    els.imageLabel.textContent = T('upload');
    if (els.backNote) els.backNote.hidden = !sideHasContent('back');
    setSelected('text');
  });

  function updatePrice() {
    const v = currentVariant();
    els.price.textContent = v ? v.price : '';
    els.submit.disabled = !v || !v.available;
    els.submit.textContent = v && !v.available ? T('js_size_unavailable') : T('add_to_cart');
  }

  // --- Ajout au panier
  els.submit.addEventListener('click', async () => {
    if (state.busy) return;
    const v = currentVariant();
    const cfgVariant = variantConfig();
    if (!v || !cfgVariant) return showError(T('js_choose'));
    const sideLayers = (side) => [state.sides[side].image, state.sides[side].text.text.trim() ? state.sides[side].text : null].filter(Boolean);
    const serialize = (l) => (l.type === 'text'
      ? { type: 'text', text: displayText(l), font: l.font, color: l.color, size: l.size, x: l.x, y: l.y, width: l.width, align: 'center', bold: l.bold, italic: l.italic, letterSpacing: l.letterSpacing }
      : (l.ai ? { type: 'image', ai: l.ai, x: l.x, y: l.y, width: l.width } : { type: 'image', data: l.data, x: l.x, y: l.y, width: l.width }));
    const sides = {};
    // all-over : chaque panneau imprimable peut porter du contenu ; ailleurs, recto et verso seulement
    for (const side of (state.aop ? AOP_PANELS : ['front', 'back'])) {
      if (sideLayers(side).length) sides[side] = sideLayers(side).map(serialize);
    }
    if (state.aop && !state.pattern?.img && !Object.keys(sides).length) return showError(T('js_add_motif'));
    if (!state.aop && !Object.keys(sides).length) return showError(T('js_add_content'));
    state.busy = true; els.submit.disabled = true; els.submit.textContent = T('js_saving'); showError('');
    try {
      const payload = state.aop
        ? { product: PRODUCT, variant_id: cfgVariant.variant_id, pattern: { library: state.pattern.library || undefined, ai: state.pattern.ai || undefined, data: (state.pattern.ai || state.pattern.library) ? undefined : state.pattern.data, scale: state.pattern.scale, mirror: state.pattern.mirror, background: state.pattern.background }, sides: { front: sides.front || [], ...Object.fromEntries(AOP_PANELS.filter((x) => x !== 'front' && sides[x]).map((x) => [x, sides[x]])) } }
        : { product: PRODUCT, variant_id: cfgVariant.variant_id, sides };
      const r = await fetch(`${BACKEND}/api/designs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error || T('js_save_error'));
      const properties = { [T('js_personalisation')]: j.summary || T('js_image'), [T('js_font')]: FONT_LABEL[state.sides.front.text.font], _verso_design: j.id, _verso_preview: j.preview_url };
      if (sides.back) { properties[T('js_back_print')] = 'oui'; properties._verso_preview_dos = j.preview_back_url; }
      const items = [{ id: v.id, quantity: 1, properties }];
      const supplement = Number(root.dataset.backVariant);
      if (sides.back && supplement && !state.aop) items.push({ id: supplement, quantity: 1, properties: { [T('js_for')]: `${document.title.split(' – ')[0]} · ${state.color} ${state.size}`, _verso_design: j.id, _verso_supplement: 'dos' } });
      const add = await fetch(root.dataset.cartUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!add.ok) throw new Error((await add.json()).description || T('js_cart_error'));
      try { localStorage.setItem('vs-cart', '1'); } catch { /* stockage indisponible */ }
      await openCrossSell(j.id);
    } catch (e) {
      showError(e.message);
      state.busy = false; updatePrice();
    }
  });

  // --- Cross-sell : la même création sur d'autres produits (aperçus rendus par le serveur, remise « Duo studio »)
  const XS_TIMEOUT_MS = 4000; // au-delà, on va au panier sans rien montrer : le cross-sell ne bloque jamais une vente
  const XS_DISCOUNT = 0.10;
  const goCart = () => { window.location.href = '/cart'; };
  const money = (cents) => new Intl.NumberFormat(root.dataset.locale || 'fr', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100);
  async function crossSellOffers(designId) {
    const ctrl = new AbortController(); const timer = setTimeout(() => ctrl.abort(), XS_TIMEOUT_MS);
    try {
      const r = await fetch(`${BACKEND}/api/designs/${encodeURIComponent(designId)}/variants`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ color: state.color, size: state.size }), signal: ctrl.signal });
      if (!r.ok) return [];
      const j = await r.json();
      const rootUrl = (root.dataset.root || '/').replace(/\/$/, '');
      const offers = await Promise.all((j.variants || []).map(async (v) => {
        try {
          const p = await (await fetch(`${rootUrl}/products/${v.product}-studio.js`, { signal: ctrl.signal })).json();
          const variant = p.variants.find((x) => String(x.id) === String(v.shopify_variant));
          if (!variant || !variant.available) return null;
          return { ...v, title: p.title.split(' ·')[0], variant };
        } catch { return null; }
      }));
      return offers.filter(Boolean);
    } catch { return []; } finally { clearTimeout(timer); }
  }
  async function openCrossSell(designId) {
    const offers = await crossSellOffers(designId);
    if (!offers.length) return goCart();
    document.querySelector('.vs__overlay')?.remove();
    const ov = document.createElement('div'); ov.className = 'vs__overlay';
    const sheet = document.createElement('div'); sheet.className = 'vs__sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = `<div class="vs__sheet-head"><div><h2>${T('js_xs_title')}</h2><p>${T('js_xs_sub')}</p></div><button type="button" class="vs__sheet-close" aria-label="${T('js_close')}">×</button></div><div class="vs__cards"></div><div class="vs__refine vs__xs-foot"><button type="button" class="vs__submit vs__xs-cart">${T('js_xs_cart')}</button></div>`;
    ov.appendChild(sheet); document.body.appendChild(ov);
    const cards = sheet.querySelector('.vs__cards');
    const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    for (const o of offers) {
      const card = document.createElement('article'); card.className = 'vs__card';
      const img = document.createElement('img'); img.src = o.preview_url; img.alt = `${o.title} · ${o.summary}`; img.width = 900; img.height = 900; img.loading = 'lazy';
      card.appendChild(img);
      const body = document.createElement('div'); body.className = 'vs__card-body';
      const variantLabel = o.size === 'Taille unique' ? o.color : `${o.color} · ${o.size}`;
      if (o.kid || o.her) card.classList.add('vs__card--kid');
      body.innerHTML = `<span class="vs__card-kicker">${o.set ? T('js_xs_set') : (o.kid ? T('js_xs_kid') : (o.her ? T('js_xs_her') : T('js_xs_kicker')))}</span><h3>${esc(o.title)}</h3><p class="vs__card-why">${esc(o.exact ? variantLabel : T('js_xs_adapted', { variant: variantLabel }))}</p><p class="vs__xs-price"><s>${money(o.variant.price)}</s> <strong>${money(Math.round(o.variant.price * (1 - XS_DISCOUNT)))}</strong></p><button type="button" class="vs__card-use">${T('js_xs_add')}</button>`;
      body.querySelector('.vs__card-use').addEventListener('click', async (e) => {
        const b = e.currentTarget; b.disabled = true; b.textContent = T('js_saving');
        try {
          const properties = { [T('js_personalisation')]: o.summary, _verso_design: o.design_id, _verso_preview: o.preview_url, _verso_parent: designId };
          const add = await fetch(root.dataset.cartUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: o.variant.id, quantity: 1, properties }] }) });
          if (!add.ok) throw new Error((await add.json()).description || T('js_cart_error'));
          b.textContent = `${T('js_xs_added')} ✓`;
        } catch (err) { b.disabled = false; b.textContent = T('js_xs_add'); showError(err.message); }
      });
      card.appendChild(body); cards.appendChild(card);
    }
    sheet.querySelector('.vs__xs-cart').addEventListener('click', goCart);
    sheet.querySelector('.vs__sheet-close').addEventListener('click', goCart);
    ov.addEventListener('click', (e) => { if (e.target === ov) goCart(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') goCart(); }, { once: true });
  }

  // --- Image générée par IA (quotas côté serveur : visiteur, IP, jour)
  function visitorId() {
    try {
      let v = localStorage.getItem('vs-visitor');
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('vs-visitor', v); }
      return v;
    } catch { return 'anonyme'; }
  }
  const hasCart = () => { try { return localStorage.getItem('vs-cart') === '1'; } catch { return false; } };
  const adminKey = () => {
    try {
      const fromUrl = new URLSearchParams(location.search).get('studio_key');
      if (fromUrl) localStorage.setItem('vs-key', fromUrl);
      return localStorage.getItem('vs-key') || '';
    } catch { return ''; }
  };
  // contexte envoyé à l'IA : produit, couleur du tissu, emplacement, surface imprimable, taille
  function aiContext() {
    const pf = state.config?.printfile;
    const area = pf && pf.dpi ? `${Math.round(pf.width / pf.dpi * 2.54)} × ${Math.round(pf.height / pf.dpi * 2.54)} cm` : null;
    const preset = Object.entries(PRESETS).find(([, p]) => Math.abs(p.x - state.text.x) < 0.01 && Math.abs(p.y - state.text.y) < 0.01)?.[0] || 'center';
    return { product: document.title.split(' – ')[0].split(' | ')[0], type: state.config?.type || 'dtg', garment: state.color || null, size: state.size || null, side: state.side, placement: state.side === 'back' ? 'back' : preset, area_cm: area, ink: INK_NAMES[state.text.color] };
  }
  const aiHeaders = () => ({ 'Content-Type': 'application/json', 'X-Verso-Visitor': visitorId(), ...(adminKey() ? { 'X-Verso-Key': adminKey() } : {}) });
  function aiStatus(msg, isError) {
    if (!els.aiStatus) return;
    els.aiStatus.textContent = msg || ''; els.aiStatus.hidden = !msg;
    els.aiStatus.style.color = isError ? '#B23A2E' : '';
  }
  function showQuota(qt) {
    if (els.aiQuota && qt) els.aiQuota.textContent = qt.admin ? T('js_admin') : (qt.remaining > 0 ? T('js_quota_left', { n: qt.remaining }) : T('js_quota_none'));
  }
  async function initAi() {
    if (!els.ai) return;
    try {
      const r = await fetch(`${BACKEND}/api/ai/quota?cart=${hasCart() ? 1 : 0}`, { headers: aiHeaders() });
      if (!r.ok) throw new Error();
      const j = await r.json();
      els.aiStyles.innerHTML = '';
      Object.entries(j.styles).forEach(([key, label], i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'vs__chip vs__chip--btn'; b.dataset.aiStyle = key; b.textContent = label;
        b.setAttribute('aria-pressed', String(i === 0));
        b.addEventListener('click', () => els.aiStyles.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b))));
        els.aiStyles.appendChild(b);
      });
      showQuota(j.quota);
    } catch { els.ai.hidden = true; }
  }
  function useAiImage(id, url, img, button) {
    els.aiResults.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === button)));
    const hasText = Boolean(state.text.text.trim());
    state.image = { type: 'image', ai: id, url, img, x: hasText ? state.text.x : 0.5, y: hasText ? Math.min(0.9, state.text.y + 0.28) : 0.4, width: Number(els.imageSize.querySelector('input').value) };
    els.imageLabel.textContent = T('js_ai_placed');
    els.imageSize.hidden = false; if (els.imageRemove) els.imageRemove.hidden = false;
    if (els.backNote) els.backNote.hidden = !sideHasContent('back');
    setSelected('image');
  }
  let aiPhotoData = null;
  els.aiPhoto?.addEventListener('change', () => {
    const file = els.aiPhoto.files[0];
    if (!file) { aiPhotoData = null; return; }
    if (file.size > 8 * 1024 * 1024) { aiStatus(T('js_photo_heavy'), true); els.aiPhoto.value = ''; return; }
    const reader = new FileReader();
    reader.onload = async () => {
      // réduction côté navigateur : 1536 px max, pour limiter le poids envoyé
      const img = new Image(); img.src = reader.result; await img.decode().catch(() => {});
      const k = Math.min(1, 1536 / Math.max(img.width, img.height));
      const cv = document.createElement('canvas'); cv.width = Math.round(img.width * k); cv.height = Math.round(img.height * k);
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      aiPhotoData = cv.toDataURL('image/jpeg', 0.9);
      els.aiPhotoLabel.textContent = `${file.name} · ${T('js_photo_ready')}`;
      els.aiGo.textContent = T('js_transform');
      if (els.aiNoLiving) els.aiNoLiving.checked = false;
    };
    reader.readAsDataURL(file);
  });
  els.aiGo?.addEventListener('click', async () => {
    const prompt = els.aiPrompt.value.trim();
    if (prompt.length < 3) return aiStatus(aiPhotoData ? T('js_describe_photo') : T('js_describe'), true);
    const style = els.aiStyles.querySelector('button[aria-pressed="true"]')?.dataset.aiStyle || 'gravure';
    els.aiGo.disabled = true; els.aiGo.textContent = T('js_generating'); aiStatus('');
    try {
      const r = await fetch(`${BACKEND}/api/ai/image`, {
        method: 'POST', headers: aiHeaders(),
        body: JSON.stringify({ prompt, style, noLiving: els.aiNoLiving.checked, ink: INK_NAMES[state.text.color], hasCart: hasCart(), image: aiPhotoData || undefined, context: aiContext() }),
      });
      const j = await r.json();
      showQuota(j.quota);
      if (!r.ok) throw new Error(j.error || T('js_ai_failed'));
      const img = new Image(); img.crossOrigin = 'anonymous'; img.src = j.url;
      await img.decode();
      const b = document.createElement('button'); b.type = 'button'; b.title = prompt;
      const thumb = document.createElement('img'); thumb.src = j.url; thumb.alt = prompt; b.appendChild(thumb);
      b.addEventListener('click', () => useAiImage(j.id, j.url, img, b));
      els.aiResults.prepend(b);
      while (els.aiResults.children.length > 4) els.aiResults.lastChild.remove();
      useAiImage(j.id, j.url, img, b);
      aiStatus(T('js_ai_done'));
    } catch (e) {
      aiStatus(e.message, true);
    } finally {
      els.aiGo.disabled = false; els.aiGo.textContent = aiPhotoData ? T('js_transform') : T('ai_go');
    }
  });

  // --- Une idée, trois T-shirts : brief IA + une image partagée, vignettes dessinées avec le même moteur
  function paintLayers(cx, W, area, list) {
    for (const layer of list) {
      cx.save();
      cx.translate(area.x + layer.x * area.w, area.y + layer.y * area.h);
      if (layer.type === 'text') {
        const { px, lines } = fitLayer(layer, area); // mesure avec le contexte principal, espacement compris
        cx.font = fontSpec(layer, px);
        cx.fillStyle = INK[layer.color];
        cx.textBaseline = 'middle'; cx.textAlign = 'center';
        cx.direction = isRtl(layer.text) ? 'rtl' : 'ltr';
        if ('letterSpacing' in cx) cx.letterSpacing = `${layer.letterSpacing * px}px`;
        const lh = px * 1.15; const total = lh * (lines.length - 1);
        stitchText(cx, px, (c) => { if (c !== cx) { c.font = cx.font; c.fillStyle = cx.fillStyle; c.textBaseline = 'middle'; c.textAlign = 'center'; c.direction = cx.direction; if ('letterSpacing' in c) c.letterSpacing = cx.letterSpacing; } lines.forEach((line, i) => c.fillText(line, 0, -total / 2 + i * lh)); });
      } else if (layer.img) {
        const w = layer.width * area.w; const h = w * (layer.img.height / layer.img.width);
        cx.drawImage(layer.img, -w / 2, -h / 2, w, h);
      }
      cx.restore();
    }
  }
  const EMB_LAYOUT = { x: 0.5, y: 0.5, size: 0.42, width: 0.95 };
  function proposalToLayers(p, img) {
    const preset = state.embroidery ? EMB_LAYOUT : (PRESETS[p.text.preset] || PRESETS.center);
    const text = { type: 'text', text: p.text.content, font: p.text.font, color: p.ink, size: preset.size, x: preset.x, y: preset.y, width: preset.width, letterSpacing: Math.min(0.4, Math.max(0, p.text.letter_spacing || 0)), bold: false, italic: Boolean(p.text.italic), upper: Boolean(p.text.upper), align: 'center' };
    const list = [];
    if (p.with_image && img) {
      const imageOnly = p.image_position === 'alone';
      const above = p.image_position === 'above';
      const image = { type: 'image', img, x: imageOnly ? 0.5 : preset.x, width: imageOnly ? 0.75 : 0.5, y: imageOnly ? 0.45 : (above ? Math.max(0.16, preset.y - 0.22) : Math.min(0.85, preset.y + 0.24)) };
      list.push(image);
      if (!imageOnly) list.push(text);
    } else list.push(text);
    return list;
  }
  async function renderProposal(p, img) {
    const variant = state.config.variants[`${p.garment_color}|${state.size}`] || state.config.variants[p.garment_color] || Object.values(state.config.variants).find((v) => true);
    const side = variant.sides?.front || variant;
    const cv = document.createElement('canvas'); cv.width = 600; cv.height = 600;
    const cx = cv.getContext('2d');
    const s = 600 / side.size;
    const area = { x: side.area.x * s, y: side.area.y * s, w: side.area.w * s, h: side.area.h * s };
    cx.fillStyle = side.background ? `#${side.background.replace('#', '')}` : '#F2E8D5'; cx.fillRect(0, 0, 600, 600);
    const tpl = new Image(); tpl.crossOrigin = 'anonymous'; tpl.src = side.template;
    const tbg = side.background_image ? Object.assign(new Image(), { crossOrigin: 'anonymous', src: side.background_image }) : null;
    await Promise.all([tpl.decode().catch(() => {}), tbg ? tbg.decode().catch(() => {}) : null]);
    cx.fillStyle = '#F2E8D5'; cx.fillRect(0, 0, 600, 600);
    const gc = document.createElement('canvas'); gc.width = 600; gc.height = 600; const gg = gc.getContext('2d'); gg.fillStyle = side.background ? `#${side.background.replace('#', '')}` : '#ffffff'; gg.fillRect(0, 0, 600, 600); if (tbg && tbg.naturalWidth) gg.drawImage(tbg, 0, 0, 600, 600); gg.drawImage(tpl, 0, 0, 600, 600);
    cx.globalCompositeOperation = 'multiply'; cx.drawImage(gc, 0, 0); cx.globalCompositeOperation = 'source-over';
    try { await document.fonts.load(`16px "${FONT_FAMILY[p.text.font]}"`); } catch { /* repli */ }
    paintLayers(cx, 600, area, proposalToLayers(p, img));
    return cv;
  }
  function applyProposal(p, img, imageId, imageUrl) {
    const radio = root.querySelector(`input[name="vs-color"][value="${p.garment_color}"]`);
    if (radio) { radio.checked = true; state.color = p.garment_color; }
    state.side = 'front';
    const preset = state.embroidery ? EMB_LAYOUT : (PRESETS[p.text.preset] || PRESETS.center);
    const front = state.sides.front;
    Object.assign(front.text, { text: p.text.content, font: p.text.font, color: p.ink, letterSpacing: Math.min(0.4, Math.max(0, p.text.letter_spacing || 0)), italic: Boolean(p.text.italic), upper: Boolean(p.text.upper), bold: false, ...preset });
    const inkRadio = root.querySelector(`input[name="vs-ink"][value="${p.ink}"]`); if (inkRadio) inkRadio.checked = true;
    if (p.image_position === 'alone' && p.with_image && img) front.text.text = '';
    if (p.with_image && img) {
      const layer = proposalToLayers(p, img).find((l) => l.type === 'image');
      front.image = { type: 'image', ai: imageId, url: imageUrl, img, x: layer.x, y: layer.y, width: layer.width };
    } else front.image = null;
    state.presetDismissed = true;
    syncLangToText();
    syncControlsToSide();
    if (els.wizard) els.wizard.open = false;
    loadTemplate();
    root.querySelector('.vs__stage')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  root.querySelectorAll('[data-example]').forEach((b) => b.addEventListener('click', () => { els.wizPrompt.value = b.dataset.example; els.wizPrompt.focus(); }));
  // --- Assistant : étapes de progression, panneau plein écran à trois cartes, raffinement
  const STEPS = [T('js_wz_step1'), T('js_wz_step2'), T('js_wz_step3'), T('js_wz_step4')];
  let lastWizard = null; // { prompt, proposals, image }
  function showProgress() {
    let box = els.wizard.querySelector('.vs__stage-progress');
    if (!box) { box = document.createElement('div'); box.className = 'vs__stage-progress'; els.proposals.before(box); }
    box.innerHTML = STEPS.map((t, i) => `<span data-state="${i === 0 ? 'active' : ''}">${t}</span>`).join('');
    let i = 0;
    const tick = setInterval(() => { const spans = box.querySelectorAll('span'); if (i < spans.length - 1) { spans[i].dataset.state = 'done'; i++; spans[i].dataset.state = 'active'; } }, 7000);
    return () => { clearInterval(tick); box.remove(); };
  }
  const DIRECTION_LABEL = { typographic: T('js_wz_typo'), text_and_image: T('js_wz_text_image'), image_led: T('js_wz_image') };
  async function openSheet(j, img, prompt) {
    document.querySelector('.vs__overlay')?.remove();
    const ov = document.createElement('div'); ov.className = 'vs__overlay';
    const sheet = document.createElement('div'); sheet.className = 'vs__sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = `<div class="vs__sheet-head"><div><h2>${T('js_wz_title')}</h2><p>« ${prompt.replace(/</g, '&lt;')} » · ${T('js_wizard_done')}</p></div><button type="button" class="vs__sheet-close" aria-label="${T('js_close')}">×</button></div><div class="vs__cards"></div><div class="vs__refine"></div>`;
    ov.appendChild(sheet); document.body.appendChild(ov);
    const cards = sheet.querySelector('.vs__cards');
    for (const p of j.proposals) {
      const card = document.createElement('article'); card.className = 'vs__card';
      card.appendChild(await renderProposal(p, img));
      const body = document.createElement('div'); body.className = 'vs__card-body';
      const sw = GARMENT[(p.garment_color || '').toLowerCase()] || '#CFC5B4';
      body.innerHTML = `<span class="vs__card-kicker">${DIRECTION_LABEL[p.direction] || ''}</span><h3>${p.title}</h3><p class="vs__card-why">${p.why || ''}</p><div class="vs__card-meta"><span><i style="background:${sw}"></i>${p.garment_color}</span><span>${FONT_LABEL[p.text.font] || p.text.font}</span>${p.image_position === 'alone' && p.with_image ? '' : `<span>${{ chest: T('chest'), center: T('center'), low: T('low') }[p.text.preset] || ''}</span>`}</div><button type="button" class="vs__card-use">${T('js_wz_use')}</button>`;
      body.querySelector('.vs__card-use').addEventListener('click', () => { ov.remove(); applyProposal(p, img, j.image?.id, j.image?.url); });
      card.appendChild(body); cards.appendChild(card);
    }
    const refine = sheet.querySelector('.vs__refine');
    refine.innerHTML = `<span>${T('js_wz_refine')}</span>`;
    for (const [label, ask] of [[T('js_wz_r1'), 'plus sobre, moins d’éléments'], [T('js_wz_r2'), 'plus audacieux, plus grand, plus de contraste'], ...(state.embroidery ? [] : [[T('js_wz_r3'), 'uniquement typographique, aucune image'], [T('js_wz_r4'), 'avec une illustration marquante']]), [T('js_wz_r5'), 'sur d’autres couleurs de vêtement']]) {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'vs__chip vs__chip--btn'; b.textContent = label;
      b.addEventListener('click', () => { ov.remove(); runWizard(prompt, ask); });
      refine.appendChild(b);
    }
    sheet.querySelector('.vs__sheet-close').addEventListener('click', () => ov.remove());
    ov.addEventListener('click', (e) => { if (e.target === ov) ov.remove(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', esc); } });
  }
  async function runWizard(prompt, refine) {
    els.wizGo.disabled = true; els.wizGo.textContent = T('js_wizard_thinking'); els.wizStatus.hidden = true; els.proposals.innerHTML = '';
    const stop = showProgress();
    try {
      const body = { product: PRODUCT, prompt, lang: state.lang, noLiving: els.wizNoLiving.checked, hasCart: hasCart(), context: aiContext() };
      if (refine) { body.refine = refine; body.avoid = (lastWizard?.proposals || []).map((p) => `${p.title} / ${p.text.content}`); if (lastWizard?.image && !/sans image|typographique/.test(refine)) body.reuse_image = lastWizard.image.id; }
      const r = await fetch(`${BACKEND}/api/ai/design`, { method: 'POST', headers: aiHeaders(), body: JSON.stringify(body) });
      const j = await r.json();
      showQuota(j.quota);
      if (!r.ok) throw new Error(j.error || T('js_wizard_failed'));
      let img = null;
      if (j.image) { img = new Image(); img.crossOrigin = 'anonymous'; img.src = j.image.url; await img.decode().catch(() => { img = null; }); }
      lastWizard = { prompt, proposals: j.proposals, image: j.image };
      await openSheet(j, img, prompt);
    } catch (e) {
      els.wizStatus.hidden = false; els.wizStatus.textContent = e.message;
    } finally {
      stop();
      els.wizGo.disabled = false; els.wizGo.textContent = T('wizard_go');
    }
  }
  els.wizGo?.addEventListener('click', () => {
    const prompt = els.wizPrompt.value.trim();
    if (prompt.length < 3) { els.wizStatus.hidden = false; els.wizStatus.textContent = T('js_wizard_describe'); return; }
    runWizard(prompt, '');
  });

  // --- Motif all-over : IA ou téléversement, échelle, miroir, fond
  async function setPatternImage(src, meta) {
    const img = new Image(); img.crossOrigin = 'anonymous'; img.src = src;
    await img.decode();
    state.pattern = { ...state.pattern, ...meta, img };
    draw();
  }
  // motif d'exemple (celui des photos de la fiche) : l'aperçu n'est jamais vide ; remplacé dès que le client génère ou téléverse
  async function loadExamplePattern(ex) {
    try {
      const r = await fetch(ex.url); const blob = await r.blob();
      const reader = new FileReader();
      const data = await new Promise((res, rej) => { reader.onload = () => res(reader.result); reader.onerror = rej; reader.readAsDataURL(blob); });
      if (els.motifScale && ex.scale) els.motifScale.value = String(ex.scale);
      const bg = root.querySelector(`input[name="vs-motif-bg"][value="${(ex.background || '').toLowerCase()}"], input[name="vs-motif-bg"][value="${(ex.background || '').toUpperCase()}"]`);
      if (bg) bg.checked = true;
      await setPatternImage(data, { ai: null, data, library: null, example: true, scale: ex.scale || 0.3, background: ex.background || '#ffffff' });
      if (els.motifStatus) { els.motifStatus.hidden = false; els.motifStatus.classList.add('vs__ai-status--example'); els.motifStatus.textContent = T('js_motif_example'); }
    } catch { /* aperçu vide, le client génère son motif */ }
  }
  root.querySelectorAll('[data-vs-motif-examples] [data-example]').forEach((b) => b.addEventListener('click', () => {
    root.querySelectorAll('[data-vs-motif-examples] [data-example]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    els.motifPrompt.value = b.dataset.example;
    const lib = state.config?.motifs?.[b.dataset.family];
    if (lib) { // motif de la bibliothèque : immédiat, sans IA ; l'IA sert à personnaliser
      els.motifStatus.hidden = true; els.motifStatus.classList.remove('vs__ai-status--example');
      setPatternImage(lib, { ai: null, data: null, library: b.dataset.family, example: false })
        .then(() => { els.motifStatus.hidden = false; els.motifStatus.textContent = T('js_motif_library'); })
        .catch(() => els.motifGo?.click());
      return;
    }
    els.motifGo?.click(); // pas encore en bibliothèque : génération
  }));
  els.motifPrompt?.addEventListener('input', () => root.querySelectorAll('[data-vs-motif-examples] [data-example]').forEach((x) => x.removeAttribute('aria-pressed')));
  els.motifGo?.addEventListener('click', async () => {
    const prompt = els.motifPrompt.value.trim();
    if (prompt.length < 3) { els.motifStatus.hidden = false; els.motifStatus.textContent = T('js_motif_describe'); return; }
    els.motifGo.disabled = true; els.motifGo.textContent = T('js_motif_generating'); els.motifStatus.hidden = true; els.motifStatus.classList.remove('vs__ai-status--example');
    try {
      const r = await fetch(`${BACKEND}/api/ai/image`, {
        method: 'POST', headers: aiHeaders(),
        body: JSON.stringify({ prompt, style: 'motif', noLiving: els.motifNoLiving.checked, ink: INK_NAMES[state.text.color], hasCart: hasCart(), context: aiContext() }),
      });
      const j = await r.json();
      showQuota(j.quota);
      if (!r.ok) throw new Error(j.error || T('js_ai_failed'));
      await setPatternImage(j.url, { ai: j.id, data: null, library: null, example: false });
      els.motifStatus.hidden = false; els.motifStatus.textContent = T('js_motif_done');
    } catch (e) {
      els.motifStatus.hidden = false; els.motifStatus.textContent = e.message;
    } finally {
      els.motifGo.disabled = false; els.motifGo.textContent = T('motif_go');
    }
  });
  els.motifFile?.addEventListener('change', () => {
    const file = els.motifFile.files[0];
    if (!file) return;
    if (file.size > 6 * 1024 * 1024) { showError(T('js_image_heavy')); els.motifFile.value = ''; return; }
    const reader = new FileReader();
    reader.onload = async () => {
      await setPatternImage(reader.result, { ai: null, data: reader.result, library: null, example: false });
      els.motifFileLabel.textContent = `${file.name} · ${T('js_motif_file')}`;
      els.motifStatus.hidden = false; els.motifStatus.classList.remove('vs__ai-status--example'); els.motifStatus.textContent = T('js_motif_ready');
    };
    reader.readAsDataURL(file);
  });
  els.motifScale?.addEventListener('input', () => { if (state.pattern) { state.pattern.scale = Number(els.motifScale.value); draw(); } });
  els.motifMirror?.addEventListener('change', () => { if (state.pattern) { state.pattern.mirror = els.motifMirror.checked; draw(); } });
  root.querySelectorAll('input[name="vs-motif-bg"]').forEach((i) => i.addEventListener('change', () => { if (state.pattern) { state.pattern.background = i.value; draw(); } }));

  // --- Mobile : l'aperçu épinglé ne doit jamais recouvrir le champ ou le bouton que l'on touche
  (function mobileStage() {
    const stage = root.querySelector('.vs__stage');
    const mq = window.matchMedia('(max-width: 900px)');
    if (!stage) return;
    const html = document.documentElement;
    const stageHeight = () => (mq.matches && getComputedStyle(stage).position === 'sticky' ? stage.getBoundingClientRect().height : 0);
    // défilement automatique (focus, scrollIntoView) : la zone recouverte par l'aperçu est retirée du haut de l'écran
    const syncPadding = () => { const h = stageHeight(); html.style.scrollPaddingTop = h ? `${Math.ceil(h + 12)}px` : ''; };
    if ('ResizeObserver' in window) new ResizeObserver(syncPadding).observe(stage);
    mq.addEventListener?.('change', syncPadding);
    syncPadding();
    const vv = window.visualViewport;
    const isField = (el) => el && root.contains(el) && el.matches('input[type=text], input[type=number], input:not([type]), textarea, select');
    const keepVisible = (el) => {
      if (!mq.matches || !el || !root.contains(el)) return;
      const top = (vv ? vv.offsetTop : 0) + stageHeight() + 8;
      const bottom = (vv ? vv.height + vv.offsetTop : window.innerHeight) - 8;
      const r = el.getBoundingClientRect();
      if (r.top < top) window.scrollBy({ top: r.top - top, behavior: 'auto' });
      else if (r.bottom > bottom) window.scrollBy({ top: Math.min(r.bottom - bottom, r.top - top), behavior: 'auto' });
    };
    // navigateurs qui ne redimensionnent pas la page sous le clavier (Safari) : l'aperçu suit le haut de la zone visible
    const followVisual = () => { stage.style.top = mq.matches && vv && vv.offsetTop > 0 && root.classList.contains('vs--typing') ? `${Math.round(vv.offsetTop)}px` : ''; };
    const setVvh = () => { html.style.setProperty('--vs-vvh', `${Math.round(vv ? vv.height : window.innerHeight)}px`); followVisual(); };
    vv?.addEventListener('scroll', followVisual);
    root.addEventListener('focusin', (e) => {
      if (!isField(e.target)) return;
      setVvh(); root.classList.add('vs--typing');
      // le clavier virtuel s'ouvre après le focus : on recale une fois la hauteur visible connue
      setTimeout(() => { setVvh(); keepVisible(e.target); }, 350);
    });
    root.addEventListener('focusout', (e) => {
      if (!isField(e.target)) return;
      setTimeout(() => { if (!isField(document.activeElement)) { root.classList.remove('vs--typing'); followVisual(); } }, 120);
    });
    vv?.addEventListener('resize', () => { setVvh(); if (isField(document.activeElement)) keepVisible(document.activeElement); });
    // clavier virtuel : la touche « OK » lance la génération (le bouton est souvent caché sous le clavier) ; Maj+Entrée garde le retour à la ligne
    [[els.wizPrompt, els.wizGo], [els.motifPrompt, els.motifGo], [els.aiPrompt, els.aiGo]].forEach(([field, go]) => {
      if (!field || !go) return;
      field.enterKeyHint = 'go';
      field.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' || e.shiftKey || e.isComposing || !field.value.trim() || go.disabled) return;
        if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
        e.preventDefault(); field.blur(); go.click();
      });
    });
    // premier contact avec l'aperçu : l'aide « touchez le texte… » a servi, elle libère la place
    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch' && e.target.closest('.vs__canvas')) root.classList.add('vs--touched');
    }, { passive: true });
  })();

  // --- Démarrage
  (async () => {
    initAi();
    updatePrice();
    try {
      await Promise.all([loadConfig(), document.fonts.load('16px "Bodoni Moda"'), document.fonts.load('16px "Jost"')]);
      applyPresetLogo();
      checkAiStatus();
      await loadTemplate();
    } catch (e) {
      showError(e.message);
    }
  })();
})();
